<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<col style="width:500px;" />
						<col style="width:300px;" />
						<col style="width:130px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>SO / Inv. No</th>
							<td colspan="2">
								<span class="int_type_no_border mgr_5">
									<SoSelect
										ref="so_dn"
										v-model.trim="so_dn"
										:initialStatusCode="user.company_id == 'newjigu' ? 'W' : 'P'"
										:initialFromDaysAgo="user.company_id == 'newjigu' ? 180 : 3"
										ph="SO No or Scan Barcode"
										@set-invoice="setInvoice"
										@search="search(true)"
										:disabled="this.modified"
									/>
								</span>
								<span class="int_type_no_border mgr_5">
									<input type="text" v-model.trim="invoice_dn" class="tbl_int" placeholder="Inv. No or Scan Barcode" @keypress.enter="search(true)" :disabled="this.modified" />
								</span>
								<a v-if="!this.modified" href="javascript:;" class="search_bt" @click="search(true)">Search</a>
								<a v-if="!this.modified" href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
								<span v-if="invoice.picker_name" style="margin-left:10px;">Picker : {{ invoice.picker_name }} </span>
							</td>

							<th>Warehouse Remark</th>
							<td>
								<input type="text" v-model.trim="invoice.wh_remark" :title="invoice.wh_remark" class="tbl_int lm_int" placeholder="Remark from Warehouse" />
								<a v-if="invoice.invoice_no" href="javascript:;" class="gray_bt" @click="updateWhRemark()">Update</a>
							</td>
						</tr>
						<tr>
							<th>Status</th>
							<td>
								<CodeSelect className="tbl_select" :codes="saleStatusCodes" :showDesc="true" :codeBold="true" :descBold="true" :disabled="true" v-model="invoice.status_code" />
							</td>
							<td rowspan="3" valign="bottom">
								<table class="list_tbl mgb_0" border="0">
									<thead>
										<tr>
											<th style="width:20%;"></th>
											<th style="width:25%;text-align:center;">Total</th>
											<th style="width:25%;text-align:center;">Packed</th>
											<th style="width:30%;text-align:center;">Back-Order</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<th>Count</th>
											<td class="al_right">{{ summary.total_count | commaSeparated }}</td>
											<td class="al_right">{{ summary.boxed_count | commaSeparated }}</td>
											<td class="al_right">
												{{ summary.scant_count | commaSeparated }}
												<span v-if="summary.balance_count > 0"
													>(<font color="red">{{ summary.balance_count | commaSeparated }}</font
													>)</span
												>
												<span v-else>(0)</span>
											</td>
										</tr>
										<tr>
											<th>Quantity</th>
											<td class="al_right">{{ summary.total_quantity | commaSeparated }}</td>
											<td class="al_right">{{ summary.boxed_quantity | commaSeparated }}</td>
											<td class="al_right">{{ summary.scant_quantity | commaSeparated }}</td>
										</tr>
									</tbody>
									<!-- <span> {{ summary.total_count }}</span> -->
								</table>
							</td>
							<th>To Warehouse Staff</th>
							<td>
								<input type="text" v-model.trim="invoice.remark2" :title="invoice.remark2" class="tbl_int full_int" readonly />
							</td>
						</tr>
						<tr>
							<th>Ship To</th>
							<td>
								<div style="float:left;">
									<PartnerSelect v-model="invoice.ship_to_code" :initialName="invoice.ship_to_name" :disabled="true" ph="Ship To" />
								</div>
							</td>
							<th>Delivery Type</th>
							<td><CodeSelect className="tbl_select" :codes="deliveryTypes" v-model="invoice.delivery_type_code" :disabled="true" /></td>
						</tr>
						<tr>
							<th>Sales Person</th>
							<td>
								<span class="int_type_no_border  mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="invoice.sales_group_code" :disabled="true"/></span>
								<a v-if="invoice.invoice_no" href="javascript:;" class="gray_bt" style="float:right;" @click="shipAddress()">Ship Address</a>
							</td>
							<th>Delivery Zone</th>
							<td>
								{{ invoice.zone_code }}
								<template v-if="user.company_id == 'beautyplus'">
									<span style="margin-left:100px;">Original Order Qty/Amount</span>
									<currency-input type="text" v-model="invoice.total_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
									<currency-input type="text" v-model="invoice.total_amount" class="tbl_int ssm_int al_right" readonly />
								</template>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="half_tbl_box" style="height:650px;">
				<div class="left_tbl">
					<h4 class="inner_h5">
						Sales Order Item(s)
						<span class="int_type mgr_15">
							<select v-model="location_code" class="tbl_select sm_int">
								<option v-for="location in locations" v-bind:value="location.code" v-bind:key="location.code">{{ location.name }}</option>
							</select>
						</span>
						<label for="whole_box_only" style="margin-left:5px;"> <input type="checkbox" id="whole_box_only" v-model="whole_box_only" :true-value="true" :false-value="false" />Whole Box Only</label>
						<label for="balance_only" style="margin-left:15px;"> <input type="checkbox" id="balance_only" v-model="balance_only" :true-value="true" :false-value="false" @change="setBalanceOnly()" />Only Back-Order Check</label>
						<a v-if="balance_only" href="javascript:void(0);" class="gray_bt mgl_15" @click="printBackOrder()">Back Order Print</a>
						<label v-if="profile.backorder_item_lock == 'Y'" for="locked_item_only" style="margin-left:5px;"> <input type="checkbox" id="locked_item_only" v-model="locked_item_only" :true-value="true" :false-value="false" />Locked Item Only</label>
						<span v-if="user.company_id == 'jc'" style="float:right;"> Total Item(s) Weight : <currency-input type="text" v-model="total_box_weight_sum" class="tbl_int ssm_int al_right" readonly/></span>
					</h4>
					<div class="fixed-table-container580">
						<div class="table-wrapper" ref="div_wrapper_item">
							<table class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:30px;"><div class="th-text">No</div></th>
										<th style="text-align:center;width:120px;">
											<div class="th-text">{{ headers.class }}</div>
										</th>
										<th style="text-align:center;width:120px;" v-if="user.company_id == 'he'"><div class="th-text">Item Code</div></th>
										<th style="text-align:center;"><div class="th-text" @click="sortName()">Name</div></th>
										<th v-if="user.company_id != 'jc'" style="text-align:center;width:120px;"><div class="th-text">Color</div></th>
										<th style="text-align:center;width:50px;" v-if="user.company_id == 'jc'"><div class="th-text">WT(LB)</div></th>
										<th style="text-align:center;width:30px;"></th>

										<th style="text-align:center;width:30px;">
											<div class="th-text"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></div>
										</th>
										<th style="text-align:center;width:40px;"><div class="th-text">OnHand</div></th>
										<th style="text-align:center;width:80px;"><div class="th-text">Loc.</div></th>

										<th style="text-align:center;width:60px;"><div class="th-text">Avail</div></th>
										<th style="text-align:center;width:60px;"><div class="th-text">Ord</div></th>
										<th style="text-align:center;width:60px;"><div class="th-text">Packed</div></th>
										<th style="text-align:center;width:60px;"><div class="th-text">Back-Ord</div></th>
									</tr>
								</thead>
								<tbody>
									<!-- <tr v-for="item in filteredItems" v-bind:key="item.invoice_item_no" v-bind:class="{ on: item.invoice_item_no == selectedItem.invoice_item_no }" @click="selectItem(item)" @dblclick="addToBox(item)"> -->
									<!-- <tr ref="item" v-for="(item, index) in filteredItems" v-bind:key="item.invoice_item_no" v-bind:class="{ on2: item.item_id == scanned_item_id }" @click="selectItem(item)" @dblclick="dblclickFromItem(item)"> -->
									<tr ref="item" v-for="(item, index) in filteredItems" v-bind:key="item.invoice_item_no" :style="jcScanRowStyle(item)" @click="selectItem(item)" @dblclick="dblclickFromItem(item)">
										<td class="al_right" :style="isJc ? jcScanRowStyle(item) : item.item_id == scanned_item_id ? 'background:#96c756' : item.invoice_item_no == selectedItem.invoice_item_no ? 'background: #c6efd2;' : ''">
											{{ index + 1 }}
										</td>
										<td
											class="al_left"
											:style="
												isJc
													? jcScanRowStyle(item)
													: item.item_id == scanned_item_id
													? 'background:#96c756'
													: item.exists_in_the_box
													? 'background: #c6efd2;'
													: item.boxed_quantity > 0
													? 'background-color: yellow;'
													: item.invoice_item_no == selectedItem.invoice_item_no
													? 'background: #c6efd2;'
													: ''
											"
										>
											<template v-if="index == 0 || (index > 0 && item.class_code != filteredItems[index - 1].class_code)">
												{{ item.class_code }}
											</template>
										</td>
										<td
											v-if="user.company_id == 'he'"
											class="al_left"
											:style="
												isJc
													? jcScanRowStyle(item)
													: item.item_id == scanned_item_id
													? 'background:#96c756'
													: item.exists_in_the_box
													? 'background: #c6efd2;'
													: item.boxed_quantity > 0
													? 'background-color: yellow;'
													: item.invoice_item_no == selectedItem.invoice_item_no
													? 'background: #c6efd2;'
													: ''
											"
										>
											{{ item.item_code }}
										</td>
										<td
											class="al_left"
											:style="
												isJc
													? jcScanRowStyle(item)
													: item.item_id == scanned_item_id
													? 'background:#96c756'
													: item.exists_in_the_box
													? 'background: #c6efd2;'
													: item.boxed_quantity > 0
													? 'background-color: yellow;'
													: item.invoice_item_no == selectedItem.invoice_item_no
													? 'background: #c6efd2;'
													: ''
											"
										>
											{{ item.name }}
										</td>
										<td
											v-if="user.company_id != 'jc'"
											class="al_left"
											:style="
												isJc
													? jcScanRowStyle(item)
													: item.item_id == scanned_item_id
													? 'background:#96c756'
													: item.exists_in_the_box
													? 'background: #c6efd2;'
													: item.boxed_quantity > 0
													? 'background-color: yellow;'
													: item.invoice_item_no == selectedItem.invoice_item_no
													? 'background: #c6efd2;'
													: ''
											"
										>
											{{ item.color_code }}
										</td>
										<td
											v-if="user.company_id == 'jc'"
											class="al_right"
											:style="
												isJc
													? jcScanRowStyle(item)
													: item.item_id == scanned_item_id
													? 'background:#96c756'
													: item.exists_in_the_box
													? 'background: #c6efd2;'
													: item.boxed_quantity > 0
													? 'background-color: yellow;'
													: item.invoice_item_no == selectedItem.invoice_item_no
													? 'background: #c6efd2;'
													: ''
											"
										>
											{{ item.weight_per_box }}
										</td>
										<td @dblclick.stop="" class="al_center" :style="isJc ? jcScanRowStyle(item) : item.invoice_item_no == selectedItem.invoice_item_no ? 'background: #c6efd2;' : item.item_id == scanned_item_id ? 'background:#96c756' : ''">
											<template v-if="index == 0 || (index > 0 && item.class_code != filteredItems[index - 1].class_code)">
												<input type="checkbox" v-model="item.class_selected" @change="classCheckChanged(item)" />
											</template>
										</td>
										<td @dblclick.stop="" class="al_center" :style="isJc ? jcScanRowStyle(item) : item.invoice_item_no == selectedItem.invoice_item_no ? 'background: #c6efd2;' : item.item_id == scanned_item_id ? 'background:#96c756' : ''">
											<input type="checkbox" v-model="item.selected" />
										</td>
										<td class="al_right" :style="isJc ? jcScanRowStyle(item) : item.invoice_item_no == selectedItem.invoice_item_no ? 'background: #c6efd2;' : item.item_id == scanned_item_id ? 'background:#96c756' : ''">
											{{ item.on_hand | commaSeparated }}
										</td>
										<td
											class="al_center truncate"
											:style="isJc ? jcScanRowStyle(item) : item.invoice_item_no == selectedItem.invoice_item_no ? 'background: #c6efd2;' : item.item_id == scanned_item_id ? 'background:#96c756' : ''"
											:title="item.location_name + '-' + item.rack"
										>
											<template v-if="user.company_id == 'beautyplus'"> {{ item.rack }} - {{ item.section }} </template>
											<template v-else> {{ item.location_name }} - {{ item.rack }} </template>
										</td>
										<td class="al_right" :style="isJc ? jcScanRowStyle(item) : item.invoice_item_no == selectedItem.invoice_item_no ? 'background: #c6efd2;' : item.item_id == scanned_item_id ? 'background:#96c756' : ''">
											{{ item.available_quantity | commaSeparated }}
										</td>
										<td class="al_right" :style="isJc ? jcScanRowStyle(item) : item.invoice_item_no == selectedItem.invoice_item_no ? 'background: #c6efd2;' : item.item_id == scanned_item_id ? 'background:#96c756' : ''">
											{{ item.quantity | commaSeparated }}
										</td>
										<!-- <td class="al_right">{{ item.scan_quantity | commaSeparated }}</td> -->
										<!-- <td class="al_right" :style="item.boxed_quantity > 0 && item.invoice_item_no == selectedItem.invoice_item_no ? 'background-color: #c6efd2;' : ''" @click="selectItem(item)"> -->
										<!-- <td class="al_right" :style="item.boxed_quantity > 0 && item.invoice_item_no == selectedItem.invoice_item_no ? 'background-color: #c6efd2;' : ''"> -->
										<td class="al_right" :style="isJc ? jcScanRowStyle(item) : item.invoice_item_no == selectedItem.invoice_item_no ? 'background: #c6efd2;' : item.item_id == scanned_item_id ? 'background:#96c756' : ''">
											{{ item.boxed_quantity | commaSeparated }}
										</td>
										<!-- <td class="al_right">{{ (item.quantity - item.boxed_quantity - (item.scan_quantity ? item.scan_quantity : 0)) | commaSeparated }}</td> -->
										<td
											class="al_right"
											:style="
												isJc
													? item.balance > 0
														? 'background-color: red;'
														: jcScanRowStyle(item)
													: !(item.balance > 0) && item.invoice_item_no == selectedItem.invoice_item_no
													? 'background: #c6efd2;'
													: item.balance > 0
													? 'background-color: red;'
													: item.item_id == scanned_item_id
													? 'background:#96c756'
													: ''
											"
										>
											<font :color="item.balance > 0 ? 'white' : 'black'">{{ item.balance | commaSeparated }}</font>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<div class="right_tbl">
					<div style="height:210px;">
						<h4 class="inner_h5">
							Box Info.
							<span style="font-weight:normal;">Total Weight :<currency-input type="text" v-model.trim="summary.total_box_weight" :precision="2" style="width:70px;margin-right:50px;" class="tbl_int ssssm_int al_right" readonly/></span>
							<input v-if="modifiable && modifiableHairplus && !boxes_locked" type="button" value="Add Box" class="gray_bt2" @click="addBox()" style="margin-top:-3px;" />
							<input v-if="modifiable && modifiableHairplus && !boxes_locked" type="button" value="Add Mul. Boxes" class="gray_bt2" @click="addMultipleBoxes()" style="margin-left:10px;margin-top:-3px;" />
							<input v-if="modifiable && modifiableHairplus && !boxes_locked" type="button" value="Del. Empty Boxes" class="gray_bt2" @click="delEmptyBoxes()" style="margin-top:-3px;margin-left:20px;" />
							<!-- #3165 : 체크한 박스들을 새 박스 1개로 통합. jc 전용이라 회사 조건을 AND 로 더한다. -->
							<input v-if="mergeBoxesUsable" type="button" value="Merge Boxes" class="gray_bt2" @click="mergeBoxesConfirm()" style="margin-top:-3px;margin-left:20px;" />
							<span style="margin-right:10px;float:right;">Count : {{ boxes.length }}</span>
						</h4>
						<div class="fixed-table-container170" ref="div_wrapper_parent">
							<div class="table-wrapper" ref="div_wrapper_box">
								<table class="list_tbl tbl_pointer">
									<thead>
										<tr>
											<!-- #3165 : 통합 선택 컬럼 (jc 전용). 옆의 3% 컬럼은 '선택한 아이템이 담긴 박스' 표시라 용도가 다르다. -->
											<th v-if="mergeBoxesUsable" style="text-align:center;width:3%;"><div class="th-text">Mrg</div></th>
											<th style="text-align:center;width:3%;"></th>
											<th style="text-align:center;width:6%;"><div class="th-text">W/No</div></th>
											<th style="text-align:center;width:7%;">
												<div class="th-text">
													<template v-if="abnormalBoxExists()">
														<span class="blink" style="color:red; font-weight:bold;">Qty</span>
													</template>
													<template v-else>
														Qty
													</template>
												</div>
											</th>
											<th v-if="user.company_id == 'jc'" style="text-align:center;width:6%;"><div class="th-text">Pallet</div></th>
											<th style="text-align:center;width:9%"><div class="th-text">WT (LB)</div></th>
											<th style="text-align:center;width:6%"><div class="th-text">L (IN)</div></th>
											<th style="text-align:center;width:6%"><div class="th-text">W (IN)</div></th>
											<th style="text-align:center;width:6%"><div class="th-text">H (IN)</div></th>
											<th style="text-align:center;width:8%"><div class="th-text">Prt / Adj</div></th>
											<th style="text-align:center;width:9%"><div class="th-text">FRT ($)</div></th>
											<th style="text-align:center;"><div class="th-text">Packer</div></th>
											<th style="text-align:center;width:15%"><div class="th-text">CRT DT</div></th>
											<th style="text-align:center;width:6%"><div class="th-text">Del</div></th>
											<!-- <th style="text-align:center;width:25%"><div class="th-text">UPD DT</div></th> -->
										</tr>
									</thead>
									<tbody>
										<tr v-for="(box, index) in boxes" v-bind:key="box.box_no" v-bind:class="{ on: box.box_no == selectedBox.box_no }" @click="selectBox(box)">
											<!-- #3165 : 행 클릭이 selectBox 토글이라 @click.stop 이 필수다. -->
											<td v-if="mergeBoxesUsable" style="text-align:center;">
												<input type="checkbox" :checked="mergeBoxNos.indexOf(box.box_no) > -1" @click.stop="toggleMergeBox(box)" />
											</td>
											<td>
												<template v-if="box.checked"
													><font color="red"><b>&#10004;</b></font></template
												>
											</td>
											<td class="al_right">
												<span v-if="!box.box_dn && box.wholebox"
													><font color="blue"><b>&#10004; </b></font></span
												>
												<font :color="box.wholebox ? 'blue' : 'black'">{{ box.box_dn ? box.box_dn : index + 1 }}</font>

												<!-- <span v-if="box.wholebox"
													><font color="blue"><b>&#10004; </b></font></span
												> -->
												<!-- {{ index + 1 }} -->
											</td>
											<td class="al_right">
												<template v-if="box.quantity > 0 && computedBoxQuantity(box.box_no) != box.quantity">
													<span class="blink" style="color:red; font-weight:bold;">{{ box.quantity | commaSeparated }}</span>
												</template>
												<template v-else>
													<!-- {{ computedBoxQuantity(box.box_no) }},{{ box.quantity | commaSeparated }} -->
													{{ box.quantity | commaSeparated }}
												</template>
											</td>
											<td v-if="user.company_id == 'jc'">
												<select v-model="box.pallet_code" class="tbl_select sssm_int">
													<option v-for="p in pallets" v-bind:value="p.code" v-bind:key="p.code">{{ p.name }} {{ p.description }}</option>
												</select>
											</td>
											<td>
												<currency-input
													ref="weight"
													@keydown.down.prevent="keyDown('weight', index)"
													@keydown.up.prevent="keyUp('weight', index)"
													@keydown.enter.prevent="keyDown('weight', index)"
													type="text"
													v-model.trim="box.weight"
													:precision="2"
													:valueRange="{ max: 10000 }"
													class="tbl_int ssssm_int al_right"
													:disabled="!modifiableHairplus"
													:readonly="user.company_id == 'jc'"
													@focus="$event.target.select()"
												/>
											</td>
											<td>
												<currency-input
													ref="length"
													@keydown.down.prevent="keyDown('length', index)"
													@keydown.up.prevent="keyUp('length', index)"
													@keydown.enter.prevent="keyDown('length', index)"
													type="text"
													v-model.trim="box.length"
													:precision="0"
													:valueRange="{ max: 10000 }"
													class="tbl_int sss2m_int al_right"
													:disabled="!modifiableHairplus"
													@focus="$event.target.select()"
												/>
											</td>
											<td>
												<currency-input
													ref="width"
													@keydown.down.prevent="keyDown('width', index)"
													@keydown.up.prevent="keyUp('width', index)"
													@keydown.enter.prevent="keyDown('width', index)"
													type="text"
													v-model.trim="box.width"
													:precision="0"
													:valueRange="{ max: 10000 }"
													class="tbl_int sss2m_int al_right"
													:disabled="!modifiableHairplus"
													@focus="$event.target.select()"
												/>
											</td>
											<td>
												<currency-input
													ref="height"
													@keydown.down.prevent="keyDown('height', index)"
													@keydown.up.prevent="keyUp('height', index)"
													@keydown.enter.prevent="keyDown('height', index)"
													type="text"
													v-model.trim="box.height"
													:precision="0"
													:valueRange="{ max: 10000 }"
													class="tbl_int sss2m_int al_right"
													:disabled="!modifiableHairplus"
													@focus="$event.target.select()"
												/>
											</td>
											<td class="al_center">
												<a v-if="box.quantity > 0 && computedBoxQuantity(box.box_no) != box.quantity" href="javascript:;" type="button" class="gray_bt2" style="color:red;" @click.stop="adjBox(box, index)">Adjust</a>
												<a v-else-if="box.quantity" href="javascript:;" type="button" class="gray_bt2" @click.stop="printBox(box.box_dn)">Print</a>
											</td>
											<template v-if="invoice.zone_code">
												<td class="al_right">{{ box.freight | toCurrency }}</td>
											</template>
											<template v-else>
												<td><currency-input type="text" v-model.trim="box.freight" :precision="2" class="tbl_int ssssm_int al_right" @focus="$event.target.select()" /></td>
											</template>
											<td :title="box.crt_name" class="truncate">{{ box.crt_name }}</td>
											<td>{{ box.crt_dt | moment('MM-DD HH:mm:ss') }}</td>
											<td class="al_center">
												<template v-if="modifiableHairplus && !boxes_locked">
													<a v-if="!box.quantity && !box.weight" href="javascript:;" type="button" class="gray_bt2" @click.stop="delBox(box, index)">Del</a>
												</template>
											</td>

											<!-- <td>{{ box.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td> -->
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>

					<div>
						<h4 class="inner_h5">
							Box Item(s)
							<input type="text" ref="barcode_to_find" class="tbl_int" v-model.trim="barcode_to_find" placeholder="Barcode Scan" autocomplete="off" style="width:120px;" @keypress.enter="findAndPut()" @focus="$event.target.select()" />
							<input
								v-if="profile.packing_by_lot == 'Y'"
								type="text"
								ref="qrcode_to_find"
								class="tbl_int"
								v-model.trim="qrcode_to_find"
								placeholder="QR Code Scan"
								autocomplete="off"
								style="width:190px;"
								@keypress.enter="findQrcode()"
								@focus="$event.target.select()"
							/>
							<input
								type="text"
								ref="barcode_whole_unit"
								class="tbl_int"
								v-model.trim="barcode_whole_unit"
								placeholder="Whole Box Unit"
								autocomplete="off"
								style="width:120px;margin-left:50px;"
								@keypress.enter="findAndPutWholeUnit()"
								@focus="$event.target.select()"
							/>
							<input
								type="text"
								ref="barcode_whole_full"
								class="tbl_int"
								v-model.trim="barcode_whole_full"
								placeholder="Whole Box Full"
								autocomplete="off"
								style="width:120px;margin-left:15px;"
								@keypress.enter="findAndPutWholeFull()"
								@focus="$event.target.select()"
							/>
							<input v-if="profile.packing_by_lot == 'N' && filteredBoxItems.length > 0" type="button" value="Clear Box" class="gray_bt" style="margin-top:0px;margin-right:5px;float:right;" @click="clearBox()" />
						</h4>

						<div class="fixed-table-container340">
							<div class="table-wrapper" ref="div_wrapper_boxed_item">
								<table class="list_tbl tbl_pointer">
									<thead>
										<tr>
											<th style="text-align:center;width:30px;"><div class="th-text">No</div></th>
											<th style="text-align:center;width:110px;">
												<div class="th-text">{{ headers.class }}</div>
											</th>
											<th style="text-align:center;"><div class="th-text">Name</div></th>
											<th v-if="user.company_id != 'jc'" style="text-align:center;width:110px;"><div class="th-text">Color</div></th>
											<th v-if="profile.packing_by_lot == 'Y'" style="text-align:center;width:80px;"><div class="th-text">Lot #</div></th>
											<!-- #3165 : 헤더는 Lot # 인데 본문은 bin 만 보여주고 있었다. 같은 품목·bin 에 다른 lot 이 있으면
										     두 행이 똑같아 보여 사용자가 지울 행을 고를 수 없다. 두 값을 각각 표시한다. -->
											<th v-if="profile.packing_by_lot == 'Y'" style="text-align:center;width:70px;"><div class="th-text">Bin</div></th>
											<th style="text-align:center;width:60px;"><div class="th-text">Qty</div></th>
										</tr>
									</thead>
									<tbody>
										<tr ref="boxed_item" v-for="(item, index) in filteredBoxItems" v-bind:key="index" @dblclick="removeFromBox(item, false)">
											<td class="al_right">{{ index + 1 }}</td>
											<td class="al_left">{{ item.class_code }}</td>
											<td class="al_left">{{ item.name }}</td>
											<td v-if="user.company_id != 'jc'" class="al_left">{{ item.color_code }}</td>
											<td v-if="profile.packing_by_lot == 'Y'" class="al_left">{{ item.lot_no }}</td>
											<td v-if="profile.packing_by_lot == 'Y'" class="al_left">{{ item.bin }}</td>
											<td class="al_right">
												<currency-input type="text" v-model.trim="item.quantity" :precision="0" class="tbl_int full_int al_right" @focus="$event.target.select()" />
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>

					<!-- <div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ shipments.length | commaSeparated }}</div> -->

					<div v-if="invoice.status_code == 'P'" class="view_bottom_bt">
						<a href="javascript:;" class="gray_bt" @click="clear()">Clear All Box Information</a>
					</div>
				</div>
				<div v-if="invoice.has_valid_additional_so" class="view_bottom_bt">
					<span style="color:red;font-weight:bold;display:inline-block;margin-top:10px;font-size:17px;">Valid additional sales order exists.({{ invoice.valid_additional_sos }})</span>
				</div>
				<div v-else-if="invoice.main_invoice_no" class="view_bottom_bt">
					<span style="color:red;font-weight:bold;display:inline-block;margin-top:10px;font-size:17px;">Master sales order exists.({{ invoice.main_so_dn }})</span>
				</div>
			</div>
		</div>

		<div class="view_bottom_bt">
			<label v-if="invoice.status_code == 'I' || invoice.status_code == 'VI'" for="apply_inv_quantity_yn" style="margin-right:10px;padding-top:3px;">
				<input type="checkbox" id="apply_inv_quantity_yn" v-model="apply_inv_quantity_yn" :true-value="'Y'" :false-value="'N'" @change="checkApplyInvoiceQuantity()" />Apply Invoice Item Quantity</label
			>
			<a v-if="modifiable" href="javascript:;" type="button" :class="invoice.invoice_no ? 'search_bt' : 'disable_bt'" @click="saveBoxItems(false)">Save & Return</a>
			<!-- <a v-if="modifiable && invoice.status_code != 'I'" href="javascript:;" type="button" :class="invoice.invoice_no ? 'search_bt' : 'disable_bt'" @click="saveBoxItems(true)">Save Only</a> -->
			<a v-if="modifiable" href="javascript:;" type="button" :class="invoice.invoice_no ? 'search_bt' : 'disable_bt'" @click="saveBoxItems(true)">Save Only</a>
			<a v-if="modifiable && invoice.status_code == 'P' && user.complete_packing" href="javascript:;" type="button" :class="invoice.invoice_no ? 'complete_bt' : 'disable_bt'" @click="completePacking()">Complete Packing</a>
			<a v-if="invoiceAddable && modifiable && invoice.status_code == 'W'" href="javascript:;" type="button" :class="invoice.invoice_no ? 'search_bt' : 'disable_bt'" @click="makeInvoice()">Make Invoice</a>
			<a v-if="modifiable && invoice.status_code == 'W' && user.complete_packing" href="javascript:;" type="button" :class="invoice.invoice_no ? 'gray_bt' : 'disable_bt'" @click="cancelPacking()">Cancel Boxing</a>

			<a href="javascript:void(0);" type="button" class="mgl_15" :class="invoice.invoice_no ? 'gray_bt' : 'disable_bt'" @click="packingLabelPrint()">Print Packing Label</a>
			<a href="javascript:void(0);" type="button" :class="invoice.invoice_no ? 'gray_bt' : 'disable_bt'" @click="() => (show_pallet_label_modal = true)">Print Pallet Label</a>
			<a v-if="pickingTicketPrintable" href="javascript:void(0);" type="button" :class="invoice.invoice_no ? 'gray_bt' : 'disable_bt'" @click="printPickingTicket()">Print Picking T.</a>

			<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="back()">Back</a>
		</div>

		<input type="hidden" id="barcode_data" />
		<input type="hidden" id="code-scan" />

		<Modal @close="closeModal" v-show="showModal && modalName == 'Weight'" :draggable="false">
			<template slot="title">Enter Weight</template>
			<template slot="body">
				<div style="width:250px; height:120px;" v-on:keyup.esc="close()">
					<table class="view_tbl">
						<colgroup>
							<col style="" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Weight</th>
								<td><currency-input type="text" v-model.trim="batchWeight" :precision="2" class="tbl_int al_right" @focus="$event.target.select()" ref="input_weight" @keypress.enter="confirmBatchBoxing(batchWeight)" /></td>
							</tr>
						</tbody>
					</table>

					<div class="view_bottom_bt" style="padding-top:20px;">
						<a href="javascript:;" type="button" class="search_bt" @click="confirmBatchBoxing(batchWeight)">OK</a>
						<a href="javascript:;" type="button" class="gray_bt" @click="closeModal()">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-show="showModal && modalName == 'MultipleBoxes'" :draggable="false">
			<template slot="title">Add Multiple Boxes</template>
			<template slot="body">
				<div style="width:240px; height:150px;" v-on:keyup.esc="close()">
					<table class="view_tbl">
						<colgroup>
							<col style="" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>No of boxes</th>
								<td class="al_right"><currency-input type="text" ref="multiple_boxes_count" v-model.trim="multipleBoxesCount" :precision="0" :valueRange="{ min: 1 }" class="tbl_int ssm_int al_right" @focus="$event.target.select()" /></td>
							</tr>
							<tr>
								<th>Weight</th>
								<td class="al_right"><currency-input type="text" v-model.trim="multipleBoxesWeight" :precision="2" :valueRange="{ min: 0 }" class="tbl_int ssm_int al_right" @focus="$event.target.select()" /></td>
							</tr>
							<tr>
								<th>
									Dimension<br />
									(L x W x H)
								</th>
								<td class="al_right">
									<currency-input type="text" v-model.trim="multipleBoxesLength" :precision="1" :valueRange="{ min: 0 }" class="tbl_int sss2m_int al_right" @focus="$event.target.select()" />
									<currency-input type="text" v-model.trim="multipleBoxesWidth" :precision="1" :valueRange="{ min: 0 }" class="tbl_int sss2m_int al_right" @focus="$event.target.select()" />
									<currency-input type="text" v-model.trim="multipleBoxesHeight" :precision="1" :valueRange="{ min: 0 }" class="tbl_int sss2m_int al_right" @focus="$event.target.select()" />
								</td>
							</tr>
						</tbody>
					</table>

					<div class="view_bottom_bt" style="padding-top:20px;">
						<a href="javascript:;" type="button" class="search_bt" @click="confirmMultipleBoxes()">OK</a>
						<a href="javascript:;" type="button" class="gray_bt" @click="closeModal()">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ShipToAddress'" :draggable="false">
			<template slot="title">Ship To Address</template>
			<template slot="body">
				<div style="width:600px; height:240px;">
					<table class="view_tbl" border="0">
						<colgroup>
							<col style="width:120px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Company Name</th>
								<td><input type="text" v-model.trim="shipToAddress.ship_to_name" class="tbl_int full_int" @focus="$event.target.select()" readonly /></td>
							</tr>
							<tr>
								<th>Address</th>
								<td>
									<input type="text" v-model.trim="shipToAddress.address_detail" class="tbl_int full_int" @focus="$event.target.select()" readonly />
									<input type="text" v-model.trim="shipToAddress.address_detail2" class="tbl_int full_int" @focus="$event.target.select()" readonly />
								</td>
							</tr>
							<tr>
								<th>City / State</th>
								<td>
									<input type="text" v-model.trim="shipToAddress.address_city" class="tbl_int half_int" @focus="$event.target.select()" readonly /> /
									<input type="text" v-model.trim="shipToAddress.address_state" class="tbl_int sssm_int" @focus="$event.target.select()" readonly />
								</td>
							</tr>
							<tr>
								<th>Zip / Country</th>
								<td>
									<input type="text" v-model.trim="shipToAddress.address_zipcode" class="tbl_int sssm_int" @focus="$event.target.select()" readonly /> /
									<input type="text" v-model.trim="shipToAddress.address_country" class="tbl_int sm_int" @focus="$event.target.select()" readonly />
								</td>
							</tr>
							<tr>
								<th>Telephone</th>
								<td><input type="text" v-model.trim="shipToAddress.telephone" class="tbl_int full_int" @focus="$event.target.select()" readonly /></td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>

		<PalletLabelPopup v-if="show_pallet_label_modal" @close="() => (show_pallet_label_modal = false)" :invoice_no="invoice.invoice_no" />
	</div>
</template>

<script>
import _ from 'lodash';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import { inputSelectOnClick } from '@/utils/etc.js';
//import { initBarcodeScanner } from '@/utils/barcode.js';
import { apiCancelPacking, apiCompletePacking, apiSoIndex, apiPackingBoxItem, apiUpdateRemarkOnly, apiPickingPrintDataList, apiPrintPickingTicket } from '@/api/sales/invoice.js';
import { apiDeleteBox, apiDeleteBoxBatch, apiInsertBox, apiUpdateBoxItemList, apiAdjustBox, apiSelectInvoice, apiClearBoxInformation, apiSelectBoxInformation, apiMergeBoxes } from '@/api/sales/boxing.js';
import SoSelect from '@/components/common/SoSelect';
import '@/assets/css/table_box.css';
import { apiGetReportTemplate, companyMrtUrl, reportMrtUrl, Report, beep, objectToFormData, PrintType } from '@/api/util';
import Modal from '@/components/common/Modal';
import PalletLabelPopup from '@/components/common/PalletLabelPopup.vue';
//import { today, daysAgo } from '@/utils/date.js';

export default {
	props: ['headers'],
	beforeRouteLeave(to, from, next) {
		if (!this.modified) next();
		else {
			if (confirm('Are you leaving without saving changes?')) next();
			else next(false);
		}
	},
	data: function() {
		return {
			backUri: '/',
			so_dn: null,
			invoice_dn: null,
			invoice: {},
			shipToAddress: {},
			items: [],
			lots: [],
			boxes: [],
			boxItems: [],

			// #3165 : 통합 대상으로 체크한 box_no 목록.
			// box.checked 를 재사용하면 안 된다 - 그건 '선택한 아이템이 담긴 박스' 표시용이고
			// selectItem() 이 아이템을 클릭할 때마다 전부 false 로 지운다.
			// box 객체에 새 속성을 붙이지 않는 이유는 boxes 가 그대로 저장 payload 로 나가기 때문이다.
			mergeBoxNos: [],

			selectedBox: {},
			selectedItem: {},

			saleStatusCodes: [],
			salesGroups: [],
			deliveryTypes: [],
			locations: [],
			location_code: null,
			pallets: [],
			balance_only: false,
			whole_box_only: false,
			locked_item_only: false,
			zoneChargeList: [],

			searching: false,

			barcode_to_find: null,
			barcode_whole_unit: null,
			barcode_whole_full: null,
			qrcode_to_find: null,

			allSelected: false,

			//filteredBoxItems: [],

			batchWeight: null,

			modalName: '',
			showModal: false,

			//batchProcessItem: {},
			//batchProcessBoxCount: 0,
			batchFrom: null,

			batchProcessItemList: [],

			modified: false,
			boxes_locked: false,

			apply_inv_quantity_yn: 'Y',

			multipleBoxesCount: 2,
			multipleBoxesWeight: 0,
			multipleBoxesLength: null,
			multipleBoxesWidth: null,
			multipleBoxesHeight: null,

			scanned_item_id: null,

			show_pallet_label_modal: false,

			// changed: false,
			// loadingCompleted: false,

			//load_complete: false,
			//box_item_modified: false,

			hairplus_authorities: ['WH06', 'HP1003', 'JOANNE', 'STEVE', 'HHP1001', 'joy', 'Wjpark'],
		};
	},
	computed: {
		isJc() {
			return this.user && this.user.company_id == 'jc';
		},
		filteredBoxItems() {
			//console.log(this.boxItems);
			//console.log(this.boxItems.filter(i => i.box_no == this.selectedBox.box_no));
			return this.boxItems.filter(i => i.box_no == this.selectedBox.box_no);
		},
		filteredItems() {
			var fis = this.items.filter(i => i.quantity > 0);

			if (this.location_code) fis = fis.filter(i => i.location_code == this.location_code);
			if (this.balance_only) fis = fis.filter(i => i.balance > 0);
			if (this.whole_box_only) fis = fis.filter(i => i.packing > 0 && i.quantity >= i.packing);

			if (this.profile.backorder_item_lock == 'Y') {
				if (this.locked_item_only) fis = fis.filter(i => i.locked);
				else fis = fis.filter(i => !i.locked);
			}

			// if (this.location_code && this.balance_only) {
			// 	return this.items.filter(i => i.location_code == this.location_code && i.balance > 0 && i.quantity > 0);
			// } else if (this.location_code && !this.balance_only) {
			// 	return this.items.filter(i => i.location_code == this.location_code && i.quantity > 0);
			// } else if (this.balance_only) {
			// 	return this.items.filter(i => i.balance > 0 && i.quantity > 0);
			// } else {
			// 	return this.items.filter(i => i.quantity > 0);
			// }

			return fis;
		},
		invoiceAddable() {
			//console.log(this.$session.get('menus').filter(m => m.path == '/sales/invoice/add' && m.modify_yn == 'N'));
			if (this.$session.get('menus').filter(m => m.path == '/sales/invoice/add' && m.modify_yn == 'Y').length > 0) return true;
			else return false;
		},
		modifiable() {
			if (this.invoice && this.invoice.status_code == 'I') return false;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		modifiableHairplus() {
			if (this.user.company_id != 'hairplus' || this.hairplus_authorities.includes(this.user.user_id)) return true;
			else if (this.invoice.status_code != 'I' && this.invoice.status_code != 'W') return true;

			return false;
		},
		// #3165 : 통합 기능은 jc 전용이다. 회사 조건을 기존 수정 가능 조건에 AND 로 더한다.
		mergeBoxesUsable() {
			return this.user.company_id == 'jc' && this.modifiable && this.modifiableHairplus && !this.boxes_locked;
		},
		total_box_weight_sum() {
			return this.items.filter(i => i.weight_per_box > 0 && i.quantity > 0).reduce((acc, cur) => acc + cur.quantity * cur.weight_per_box, 0);
		},
		summary() {
			var sm = {
				total_count: this.items.length,
				boxed_count: this.items.filter(i => i.boxed_quantity > 0).length,
				scant_count: this.items.filter(i => !(i.boxed_quantity > 0)).length,
				balance_count: this.items.filter(i => i.balance > 0).length,
			};

			var total_quantity = 0;
			this.items.forEach(i => {
				total_quantity += i.quantity;
			});
			sm.total_quantity = total_quantity;

			var boxed_quantity = 0;
			this.items.forEach(i => {
				boxed_quantity += i.boxed_quantity;
			});
			sm.boxed_quantity = boxed_quantity;
			sm.scant_quantity = sm.total_quantity - sm.boxed_quantity;

			var total_box_weight = 0;
			this.boxes.forEach(b => {
				total_box_weight += b.weight;
			});
			sm.total_box_weight = total_box_weight;
			//console.log(sm);
			return sm;
		},
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		pickingTicketPrintable() {
			return this.invoice && this.invoice.invoice_no && ['A', 'P', 'W', 'I'].includes(this.invoice.status_code);
		},
		// fp() {
		// 	var fpVal = '';
		// 	this.items.forEach(item => {
		// 		fpVal += item.invoice_item_no + item.boxed_quantity + item.balalnce;
		// 	});

		// 	return fpVal;
		// },
	},
	watch: {
		// items: function() {
		// 	console.log('test');
		// },
		// invoice: {
		// 	deep: true,
		// 	handler: function(newVal, oldVal) {
		// 		console.log(newVal.ship_to_code, oldVal.ship_to_code);
		// 		if (newVal.ship_to_code != oldVal.ship_to_code) {
		// 			//console.log('ship to code changed to', newVal.ship_to_code);
		// 		}
		// 	},
		// },
		items: {
			deep: true,
			handler: function() {
				if (this.invoice.invoice_type == 'S') {
					var vm = this;
					this.items.forEach(item => {
						item.balance = item.quantity - item.boxed_quantity; // - (item.scan_quantity ? item.scan_quantity : 0);
						if (item.balance < 0) {
							const box_dn = vm.getBox(item.invoice_item_no);
							this.$toast.error('Over Scan Item. Box No : ' + box_dn);
						}
						//console.log(item.balance);
					});
				}

				//if (fpVal != '' && fpVal)

				//if (this.loadingCompleted) this.changed = true;
				//else this.loadingCompleted = true;
			},
		},
		boxItems: {
			deep: true,
			handler: function() {
				//this.calTotal();
				if (this.selectedBox) {
					var total_quantity = 0;
					this.boxItems.forEach(item => {
						if (item.box_no == this.selectedBox.box_no) total_quantity += item.quantity;
					});
					this.selectedBox.quantity = total_quantity;
				}

				// if (this.load_complete) {
				// 	this.box_item_modified = true;
				// 	console.log('box item modified');
				// }

				var vm = this;

				this.boxItems.forEach(item => {
					if (item.quantity != item.original_quantity) {
						var changed_quantity;
						if (item.quantity && item.original_quantity) changed_quantity = item.quantity - item.original_quantity;
						else if (item.quantity) changed_quantity = item.quantity;
						else if (item.original_quantity) changed_quantity = -1 * item.original_quantity;

						//console.log('changed quantity', changed_quantity);

						var found_item = vm.findItem(item.invoice_item_no);
						found_item.boxed_quantity += changed_quantity;
						item.original_quantity = item.quantity;
						/*
						found_item.scan_quantity = changed_quantity;
						if (found_item.scan_quantity > found_item.balance) {
							//console.log('Over...');
							this.$toast.error('Over Scan Item');

							//found_item.scan_quantity = 0;
							//item.quantity = item.original_quantity;
						}
						//vm.items.splice(idx, 1);

						// if (found_item.scan_quantity) found_item.scan_quantity += changed_quantity;
						// else found_item.scan_quantity = changed_quantity;
						*/
					}
				});
				//console.log('테스트');
				//var vm = this;
				// newVal.filter(function(p, idx) {
				// 	return Object.keys(p).some(function(prop) {
				// 		var diff = p[prop] !== oldVal[idx][prop];
				// 		if (diff) {
				// 			//p.changed = true;
				// 			console.log(prop);
				// 		}
				// 	});
				// });
				//newVal.amount = newVal.quantity * newVal.
				//console.log(newVal, oldVal);
				// if (newVal.class_code != oldVal.class_code) {
				// 	console.log('class code changed from', oldVal.class_code, newVal.class_code);
				// }
			},
		},

		boxes: {
			deep: true,
			handler: function() {
				this.boxes.forEach(box => {
					if (this.invoice.zone_code) box.freight = this.calFreight(box.weight);

					if (this.user.company_id == 'jc') {
						var vm = this;

						var computed_weight = vm.getPalletWeight(box.pallet_code) + this.boxItems.filter(i => i.box_no == box.box_no && i.weight_per_box > 0 && i.quantity).reduce((acc, cur) => acc + cur.quantity * cur.weight_per_box, 0);
						// Keep manually-entered weight (Add Mul. Boxes) until pallet/items produce a real (>0) value
						if (!box.manual_weight || computed_weight > 0) box.weight = computed_weight;
					}
				});
			},
		},
	},
	// watch: {
	// 	barcode_data: function(newVal) {
	// 		console.log('Hmmm', newVal);
	// 		if (newVal) {
	// 			this.sono = newVal;
	// 		}
	// 	},
	// },
	components: {
		CodeSelect,
		PartnerSelect,
		SoSelect,
		Modal,
		PalletLabelPopup,
	},
	methods: {
		getPalletWeight(pallet_code) {
			let pallet = this.pallets.filter(p => p.code == pallet_code)[0];

			if (pallet && Number(pallet.description) > 0) return Number(pallet.description);
			else return 0;
		},
		shipAddress() {
			this.modalName = 'ShipToAddress';
			this.showModal = true;
		},
		async updateWhRemark() {
			if (this.invoice.wh_remark) {
				if (this.invoice.front_remark) this.invoice.remark = this.invoice.front_remark + ' || ' + this.invoice.wh_remark;
				else this.invoice.remark = '|| ' + this.invoice.wh_remark;
			} else this.invoice.remark = this.invoice.front_remark;

			//console.log(this.invoice.front_remark, this.invoice.wh_remark, this.invoice.remark);

			//var dummy = true;
			//if (dummy) return;
			const { data } = await apiUpdateRemarkOnly(this.invoice);
			if (data.result) {
				this.$toast.success('Saved successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		clear() {
			beep();
			this.$alertify.confirm('Are you sure to clear all box information including registerd by other user(s)?', () => {
				this.clearConfirm();
			});
		},
		async clearConfirm() {
			const { data } = await apiClearBoxInformation({
				invoice_no: this.invoice.invoice_no,
				for_boxing: true,
			});

			if (data.result) {
				this.$toast.success('Cleared successfully');
				await this.search(false);
			} else {
				this.$toast.error(data.msg);
				this.markBoxesLocked(data);
			}
		},
		abnormalBoxExists() {
			var rv = false;
			var vm = this;
			this.boxes.forEach(b => {
				if (b.quantity > 0 && vm.computedBoxQuantity(b.box_no) != b.quantity) rv = true;
			});

			return rv;
		},
		computedBoxQuantity(box_no) {
			var box_sum = 0;
			//console.log(this.boxItems.filter(i => i.box_no == box_no));
			this.boxItems
				.filter(i => i.box_no == box_no)
				.forEach(b => {
					box_sum += b.quantity;
				});
			return box_sum;
		},
		sortName() {
			//console.log('sort Name');
			this.items = _.sortBy(this.items, 'name');
		},
		async selectInvoiceForPacked() {
			const { data } = await apiSelectInvoice({
				so_dn: this.so_dn,
				invoice_dn: this.invoice_dn,
			});

			return data.invoice;
		},
		keyDown(ref, index) {
			if (index < this.boxes.length - 1) {
				this.$refs[ref][index + 1].$el.select();
				if (this.$refs[ref][index + 1].$el.offsetParent.offsetTop + 2 * this.$refs[ref][index + 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
					this.$refs.div_wrapper_box.scrollTop += this.$refs[ref][index + 1].$el.offsetParent.scrollHeight + 1;
				}
			}
		},
		keyUp(ref, index) {
			if (index > 0) {
				this.$refs[ref][index - 1].$el.select();
				if (this.$refs.div_wrapper_box.scrollTop > this.$refs[ref][index - 1].$el.offsetParent.offsetTop) this.$refs.div_wrapper_box.scrollTop = this.$refs[ref][index - 1].$el.offsetParent.offsetTop;
			}
		},
		selectAll() {
			//console.log(this.allSelected);

			var vm = this;
			this.filteredItems.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		checkApplyInvoiceQuantity() {
			if ((this.invoice.status_code == 'I' || this.invoice.status_code == 'VI') && this.apply_inv_quantity_yn == 'Y')
				this.$toast.warning('Saving may influence the Invoice information. Please check the quantities and amounts in the Invoice Detail page after saving');
			//if (this.invoice.status_code == 'I') alert('Invoice quantity might have been modified. Please check the invoice quantities in the Invoice Detail page.');
		},
		classCheckChanged(item) {
			//console.log(item.class_code, item.class_selected);
			this.filteredItems
				.filter(i => i.class_code == item.class_code)
				.forEach(i => {
					i.selected = item.class_selected;
				});

			//this.$forceUpdate();
		},
		async checkValid(forOperation) {
			var invoiceToPacked = await this.selectInvoiceForPacked();

			if (!invoiceToPacked) {
				this.$toast.error('Not found');
				return false;
			}

			// W : Complete, C : Cancel, I : Invoicing, S : Save
			if (forOperation == 'W' || forOperation == 'I') {
				if (invoiceToPacked.status_code == 'I' || invoiceToPacked.status_code == 'VI') {
					this.$toast.error('This SO was already invoiced');
					return false;
				} else if (forOperation == 'W' && invoiceToPacked.status_code == 'W') {
					this.$toast.error('This SO was already packed');
					return false;
				} else if (invoiceToPacked.status_code == 'V' || invoiceToPacked.status_code == 'VI') {
					this.$toast.error('Void Sales Order or Invoice');
					return false;
				}
			} else if (forOperation == 'C' && invoiceToPacked.status_code != 'W') {
				this.$toast.error('This SO is not in Packed status');
				return false;
			}

			return true;
		},
		async checkEmptyBoxes() {
			if (this.user.company_id != 'beautyplus' && this.user.box_adding) return true;

			var emptyBoxNos = '';
			for (var i = 0; i < this.boxes.length; i++) {
				//if (!this.boxes[i].quantity && !this.boxes[i].weight) emptyBoxNos += i + 1 + ' ';
				if (!this.boxes[i].quantity) emptyBoxNos += i + 1 + ' ';
			}
			emptyBoxNos = emptyBoxNos.trim();

			if (emptyBoxNos) {
				beep();
				this.$alertify.alert('Alert', 'Box No (' + emptyBoxNos + ') is empty. Please delete empty box(es) first.');
				return false;
			}

			return true;
		},
		async checkEmptyWeight() {
			if (this.user.company_id != 'beautyplus' && this.user.box_adding) return true;

			var emptyBoxNos = '';
			for (var i = 0; i < this.boxes.length; i++) {
				//if (!this.boxes[i].quantity && !this.boxes[i].weight) emptyBoxNos += i + 1 + ' ';
				if (!this.boxes[i].weight) emptyBoxNos += i + 1 + ' ';
			}
			emptyBoxNos = emptyBoxNos.trim();

			if (emptyBoxNos) {
				beep();
				this.$alertify.alert('Alert', 'Box No (' + emptyBoxNos + ') have(has) empty weight.');
				return false;
			}

			return true;
		},
		checkOverScan() {
			if (this.user.company_id != 'hairplus') return;

			//console.log('test');
			var vm = this;
			var msg = '';
			this.items.forEach(item => {
				if (item.quantity - item.boxed_quantity < 0) {
					const box_dn = vm.getBox(item.invoice_item_no);

					//console.log(box_dn, item.class_code + '-' + item.color_code);
					msg += 'Box No (' + box_dn + ') has over stock item : ' + item.class_code + '-' + item.color_code + '<br/>';
				}

				//console.log(item.balance);
			});

			if (msg) {
				beep();
				this.$alertify.alert('Alert', 'Over stock item exists.<br/><br/>' + msg);
			}
		},
		getBox(invoice_item_no) {
			//console.log(invoice_item_no);
			var vm = this;
			var rv = null;
			this.boxItems.forEach(boxItem => {
				if (invoice_item_no == boxItem.invoice_item_no) {
					const idx = this.boxes.findIndex(function(box) {
						return box.box_no === boxItem.box_no;
					});
					//console.log('found', idx);
					if (idx > -1) {
						rv = vm.boxes[idx].box_dn;
						//console.log('hmmm', vm.boxes[idx].box_dn);
						///return vm.boxes[idx].box_dn;
					} //else return null;
				}
			});
			return rv;
		},
		async completePacking() {
			// if (!(await this.checkValid('W'))) return;

			// if (!(await this.checkEmptyBoxes())) return;

			// if (!(await this.checkEmptyWeight())) return;

			beep();
			this.$alertify
				.confirm('Do you want to finish packing?', () => {
					this.completePackingConfirm();
				})
				.set('type', 'color');

			// //console.log(this.selectedInvoices);
			// await this.saveBoxItems(true);
			// //await this.delEmptyBoxes();

			// const { data } = await apiCompletePacking(this.invoice);

			// if (data.result) {
			// 	this.$toast.success('Packing Completed');
			// 	//await this.packingLabelPrint();
			// 	this.invoice.status_code = 'W';

			// 	if (data.msg) {
			// 		//alert(data.msg);
			// 		this.$alertify.alert('Alert', data.msg);
			// 		await this.search(false);
			// 	}
			// 	// this.search();
			// } else {
			// 	this.$toast.error(data.msg);
			// }
		},
		async completePackingConfirm() {
			if (!(await this.checkValid('W'))) return;

			if (!(await this.checkEmptyBoxes())) return;

			if (!(await this.checkEmptyWeight())) return;

			this.checkOverScan();

			//console.log(this.selectedInvoices);
			// 저장이 실패하면(예: 박스 수량 범위 초과) 여기서 중단한다.
			// 실패를 무시하고 진행하면 작업자의 편집이 저장되지 않은 채 박싱이 완료된다.
			if (!(await this.saveBoxItems(true))) return;
			//await this.delEmptyBoxes();

			const { data } = await apiCompletePacking(this.invoice);

			if (data.result) {
				this.$toast.success('Packing Completed');
				//await this.packingLabelPrint();
				this.invoice.status_code = 'W';

				if (data.msg) {
					//alert(data.msg);
					beep();
					this.$alertify.alert('Alert', data.msg);
					await this.search(false);
				}
				// this.search();
			} else {
				this.$toast.error(data.msg);
			}
		},
		makeShipmentAddress(shipment) {
			let address = '';
			if (!shipment) return address;

			if (shipment.ship_to_name) address += shipment.ship_to_name + '\n';
			if (shipment.address_detail) address += shipment.address_detail + (shipment.address_detail2 ? ' ' + shipment.address_detail2 : '') + '\n';
			if (shipment.address_city) address += shipment.address_city + ', ';
			if (shipment.address_state) address += shipment.address_state + ' ';
			if (shipment.address_zipcode) address += shipment.address_zipcode;
			if (shipment.address_country_name) address += ' (' + shipment.address_country_name + ')';

			return address;
		},
		async printBackOrder() {
			var param = {
				so_dn: this.so_dn,
				invoice_dn: this.invoice_dn,
				for_boxing: true,
			};

			const { data } = await apiSelectInvoice(param);
			let invoice = null;

			if (data.invoice) {
				invoice = data.invoice;
				const items = Array.isArray(data.invoiceItemList) ? data.invoiceItemList : [];
				items.forEach(item => (item.balance = item.quantity - item.boxed_quantity));

				invoice.items = items.filter(i => i.balance > 0 && i.quantity > 0);
			}

			if (!invoice || !invoice.items.length) {
				this.$toast.error('No Back-Order Item(s).');
				return;
			}

			const reportTemplate = await apiGetReportTemplate('BackOrderBySO', reportMrtUrl('BackOrderBySO'));
			const report = new Report(reportTemplate, invoice, 'BackOrderBySO');
			this.$store.commit('setReport', report);
		},
		async printPickingTicket() {
			if (!this.pickingTicketPrintable) return;
			if (this.invoice.status_code === 'A' && this.modified) {
				this.$alertify.alert('Alert', "When Status of Invoice is 'A'(Approval),<br />Please Print Picking Ticket After Save Changes of This S/O.");
				return;
			}

			try {
				const { data } = await apiPickingPrintDataList(objectToFormData({ invoiceNos: this.invoice.invoice_no }));
				const reportTemplate = await apiGetReportTemplate('Picking', companyMrtUrl('Picking'));
				const report = new Report(reportTemplate, data.data[0], 'Picking', PrintType.Normal);
				this.$store.commit('setReport', report);
				// Print Picking Ticket 이력 Update
				const { status } = await apiPrintPickingTicket(this.invoice);
				// status_code가 'A'pproval인 경우, PickingTicket 출력 후 'P'acking으로 status_code가 변함.
				if (status && this.invoice.status_code === 'A') await this.search(false);
				this.$toast.success('Picking Ticket Printed Successfully');
			} catch (error) {
				this.$toast.error('Picking Ticket error');
			}
		},
		async packingLabelPrint() {
			const { data } = await apiPackingBoxItem(this.invoice.invoice_no);
			data.ship_to_address = this.makeShipmentAddress(data.shipment);
			data.list.forEach(function(value, index) {
				value.frontBoxNo = index + 1;
			});

			if (data.result) {
				const reportTemplate = await apiGetReportTemplate('PackingBox', companyMrtUrl('PackingBox'));
				const report = new Report(reportTemplate, data, 'PackingBox');
				this.$store.commit('setReport', report);
			}
		},
		async cancelPacking() {
			if (!(await this.checkValid('C'))) return;
			const { data } = await apiCancelPacking(this.invoice);

			if (data.result) {
				this.$toast.success('Packing Canceled');
				this.search(false);
			} else {
				this.$toast.error(data.msg);
			}
		},
		async makeInvoice() {
			if (!(await this.checkValid('I'))) return;

			const { data } = await apiSelectBoxInformation({
				invoice_no: this.invoice.invoice_no,
			});

			if (this.user.company_id == 'beautyplus' && data.boxList.length == 0) {
				this.$alertify.alert('Alert', 'There is no box');
			} else if (data.boxList.length > 0 && data.boxList.filter(b => !(b.weight > 0)).length > 0) {
				this.$alertify.alert('Alert', 'Exists box(es) with no weight');
			} else {
				this.$router.push({ name: 'invoiceDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath, invoice_no: this.invoice.invoice_no } });
			}
		},
		async saveBoxItems(stay) {
			if (!(await this.checkValid('S'))) return;

			//if ((this.invoice.status_code == 'I' || this.invoice.status_code == 'VI') && !(await this.checkEmptyBoxes())) return;
			if (!(await this.checkEmptyBoxes())) return;

			if (!(await this.checkEmptyWeight())) return;

			this.checkOverScan();
			// if (!this.selectedBox.box_no) {
			// 	this.$toast.error('Box Not Selected');
			// 	return;
			// }

			// if (!this.changed) {
			// 	//this.$toast.error('Nothing changed');
			// 	return;
			// }
			// if (this.invoice.status_code == 'I' && this.box_item_modified && this.apply_inv_quantity_yn == 'N') {
			// 	this.$toast.error('Box item(s) changed. You should check "Apply Invoice Quantity" checkbox');
			// 	return;
			// }

			//console.log(this.selectedBox.box_no, this.boxItems);
			var param = {
				invoice_no: this.invoice.invoice_no,
				apply_inv_quantity_yn: this.apply_inv_quantity_yn,

				//box_no: this.selectedBox.box_no,
				items: this.boxItems,
				boxes: this.boxes,

				for_boxing: true,
			};

			if (this.invoice.status_code == 'I' || this.invoice.status_code == 'VI') {
				beep();
				alert('Invoice information might have been modified. Please check the invoice quantities and amounts in the Invoice Detail page.');

				if (this.apply_inv_quantity_yn == 'Y') param.update_on_hand = true;
			}

			const { data } = await apiUpdateBoxItemList(param);

			if (data.result) {
				this.modified = false;
				//console.log(data);
				this.items = data.invoiceItemList;
				this.boxItems = data.boxItemList;
				this.boxItems.forEach(bi => {
					bi.original_quantity = bi.quantity;
				});
				this.$toast.success('Saved Successully');

				if (!stay) {
					this.$router.push(this.backUri);
				} /* else {
					this.search(false);
				} */

				return true;
			} else {
				this.$toast.error(data.msg);
				return false;
			}
		},
		back() {
			this.$router.push(this.backUri);
		},
		calFreight(weight) {
			if (!weight || weight <= 0) return 0;

			var candidate = 0;
			if (this.zoneChargeList.length > 0) candidate = this.zoneChargeList[0].charge;

			for (var i = 0; i < this.zoneChargeList.length - 1; i++) {
				if (weight > this.zoneChargeList[i].to_weight) candidate = this.zoneChargeList[i + 1].charge;
				else return candidate;
			}
			return candidate;
		},
		findItem(invoice_item_no) {
			for (var i = 0; i < this.items.length; i++) {
				if (this.items[i].invoice_item_no == invoice_item_no) return this.items[i];
			}
			return null;
		},
		findItemByItemCode(item_code) {
			for (var i = 0; i < this.items.length; i++) {
				if (this.items[i].item_code == item_code) return this.items[i];
			}
			return null;
		},
		findItemFromBoxByLot(box_no, invoice_item_no, lot_no) {
			for (var i = 0; i < this.boxItems.length; i++) {
				if (this.boxItems[i].box_no == box_no && this.boxItems[i].invoice_item_no == invoice_item_no && this.boxItems[i].lot_no == lot_no) return this.boxItems[i];
			}
			return null;
		},
		findItemFromBox(box_no, invoice_item_no) {
			for (var i = 0; i < this.boxItems.length; i++) {
				if (this.profile.packing_by_lot == 'Y') {
					if (this.boxItems[i].box_no == box_no && this.boxItems[i].invoice_item_no == invoice_item_no && !this.boxItems[i].lot_no) return this.boxItems[i];
				} else {
					if (this.boxItems[i].box_no == box_no && this.boxItems[i].invoice_item_no == invoice_item_no) return this.boxItems[i];
				}
			}
			return null;
		},

		findIndexInItems(invoice_item_no) {
			for (var i = 0; i < this.filteredItems.length; i++) {
				if (this.filteredItems[i].invoice_item_no == invoice_item_no) return i;
			}
			return -1;
		},

		findQrcode() {
			if (!this.qrcode_to_find) return;

			if (!this.qrcode_to_find.includes('|')) {
				this.$toast.error('Invalid QR Code');
				return;
			}

			//console.log(this.lots);

			const item_code = this.qrcode_to_find.split('|')[0];
			const b_type = this.qrcode_to_find.split('|')[1];
			const bin = this.qrcode_to_find.split('|')[2];

			//			console.log(this.qrcode_to_find);

			var f_items = this.lots.filter(l => l.item_code == item_code && l.bin == bin);
			//console.log(f_items);
			if (f_items.length == 0) {
				this.$toast.error('Item not found in this order');
			} else {
				this.addToBoxByQrcode(f_items[0], b_type);
			}

			this.$refs.qrcode_to_find.select();

			//this.barcode_to_find = '';
		},

		playScanSound(type) {
			if (!this.user || this.user.company_id != 'jc') return;
			try {
				const AC = window.AudioContext || window.webkitAudioContext;
				if (!AC) return;
				if (!this._scanAudioCtx) this._scanAudioCtx = new AC();
				const ctx = this._scanAudioCtx;
				if (ctx.state === 'suspended') ctx.resume();
				const beep = (freq, start, dur) => {
					const osc = ctx.createOscillator();
					const gain = ctx.createGain();
					osc.connect(gain);
					gain.connect(ctx.destination);
					osc.type = 'square';
					osc.frequency.value = freq;
					gain.gain.setValueAtTime(1.0, start);
					gain.gain.exponentialRampToValueAtTime(0.001, start + dur);
					osc.start(start);
					osc.stop(start + dur);
				};
				const now = ctx.currentTime;
				if (type == 'ok') {
					beep(1046, now, 0.12);
				} else {
					// 삐빅 - double warning beep
					beep(740, now, 0.12);
					beep(740, now + 0.17, 0.3);
				}
			} catch (e) {
				/* audio not critical */
			}
		},
		jcScanRowStyle(item) {
			if (!this.isJc) return '';
			const ord = Number(item.quantity) || 0;
			const packed = Number(item.boxed_quantity) || 0;
			if (packed <= 0) return '';
			if (ord > 0 && packed >= ord) return 'background:#96c756';
			return 'background:#ffe066';
		},
		scanBlockAlert(title, msg) {
			if (!this.user || this.user.company_id != 'jc') return;
			this.$alertify.alert(title, msg);
		},
		matchesExtraBarcode(item, code) {
			// #3145 jc 추가 UPC(barcode3~9) 매칭 - 매칭된 슬롯 번호(3~9), 없으면 0 반환
			if (!code) return 0;
			for (var n = 3; n <= 9; n++) {
				var bc = item['barcode' + n];
				if (bc && String(bc).toUpperCase() == code.toUpperCase()) return n;
			}
			return 0;
		},
		findAndPut() {
			if (!this.barcode_to_find) return;

			/*
			console.log(this.barcode_to_find);

			console.log(this.filteredItems); */
			var b_type = 'PC';
			var f_items = this.filteredItems.filter(i => i.barcode && this.barcode_to_find && i.barcode.toUpperCase() == this.barcode_to_find.toUpperCase());

			if (f_items.length == 0) {
				b_type = 'BX';
				f_items = this.filteredItems.filter(i => i.barcode_box && this.barcode_to_find && i.barcode_box.toUpperCase() == this.barcode_to_find.toUpperCase());
			}

			if (f_items.length == 0) {
				b_type = 'CS';
				f_items = this.filteredItems.filter(i => i.barcode_case && this.barcode_to_find && i.barcode_case.toUpperCase() == this.barcode_to_find.toUpperCase());
			}

			var multiply_qty = null;
			if (f_items.length == 0 && this.isJc) {
				// #3145 추가 UPC(barcode3~9) 스캔 - 슬롯별 Multiply Qty(기본 1)만큼 가산
				b_type = 'PC';
				f_items = this.filteredItems.filter(i => this.matchesExtraBarcode(i, this.barcode_to_find));
				if (f_items.length > 0) {
					var extra_slot = this.matchesExtraBarcode(f_items[0], this.barcode_to_find);
					multiply_qty = Number(f_items[0]['barcode' + extra_slot + '_qty']) || 1;
				}
			}

			if (f_items.length == 0) {
				this.$toast.error('Barcode ' + this.barcode_to_find + ' item not found in this order');
				this.playScanSound('error');
				this.scanBlockAlert('Item not found', 'Barcode # ' + this.barcode_to_find + ' is not found in this order!<br>Please check the Barcode # and try again.');
			} else {
				this.addToBox(f_items[0], false, null, b_type, multiply_qty);

				var index = this.findIndexInItems(f_items[0].invoice_item_no);
				//console.log(index);
				this.$nextTick(function() {
					if (index >= 0) this.$refs.div_wrapper_item.scrollTop = this.$refs['item'][index].offsetTop;
				});
			}

			this.$refs.barcode_to_find.select();

			//this.barcode_to_find = '';
		},
		async findAndPutWholeUnit() {
			if (!this.barcode_whole_unit) return;

			var f_items = this.filteredItems.filter(i => i.barcode && this.barcode_whole_unit && i.barcode.toUpperCase() == this.barcode_whole_unit.toUpperCase());
			if (f_items.length == 0 && this.isJc) f_items = this.filteredItems.filter(i => this.matchesExtraBarcode(i, this.barcode_whole_unit)); // #3145
			if (f_items.length == 0) {
				this.$toast.error('Barcode ' + this.barcode_whole_unit + ' item not found in this order');
				this.playScanSound('error');
				this.scanBlockAlert('Item not found', 'Barcode # ' + this.barcode_whole_unit + ' is not found in this order!<br>Please check the Barcode # and try again.');
			} else {
				await this.addToBox(f_items[0], true, 'unit');
				this.barcode_whole_unit = null;

				var index = this.findIndexInItems(f_items[0].invoice_item_no);
				this.$nextTick(function() {
					if (index >= 0) this.$refs.div_wrapper_item.scrollTop = this.$refs['item'][index].offsetTop;
				});
			}

			// this.$nextTick(() => {
			// 	this.$refs.barcode_whole_unit.focus();
			// });

			//this.barcode_to_find = '';
		},
		async findAndPutWholeFull() {
			if (!this.barcode_whole_full) return;

			var f_items = this.filteredItems.filter(i => i.barcode && this.barcode_whole_full && i.barcode.toUpperCase() == this.barcode_whole_full.toUpperCase());
			if (f_items.length == 0 && this.isJc) f_items = this.filteredItems.filter(i => this.matchesExtraBarcode(i, this.barcode_whole_full)); // #3145
			if (f_items.length == 0) {
				this.$toast.error('Barcode ' + this.barcode_whole_full + ' item not found in this order');
				this.playScanSound('error');
				this.scanBlockAlert('Item not found', 'Barcode # ' + this.barcode_whole_full + ' is not found in this order!<br>Please check the Barcode # and try again.');
			} else {
				await this.addToBox(f_items[0], true, 'full');
				this.barcode_whole_full = null;

				var index = this.findIndexInItems(f_items[0].invoice_item_no);
				this.$nextTick(function() {
					if (index >= 0) this.$refs.div_wrapper_item.scrollTop = this.$refs['item'][index].offsetTop;
				});
			}

			// this.$nextTick(() => {
			// 	this.$refs.barcode_whole_full.focus();
			// });

			//this.$refs.barcode_whole_full.select();

			//this.barcode_to_find = '';
		},
		closeModal() {
			this.showModal = false;
			this.$nextTick(() => {
				if (this.batchFrom == 'full') this.$refs.barcode_whole_full.select();
				else if (this.batchFrom == 'unit') this.$refs.barcode_whole_unit.select();
			});
		},

		async confirmBatchBoxing(weight) {
			//var toAddBoxCount = this.batchProcessItem.balance / this.batchProcessItem.packing;

			for (var bi = 0; bi < this.batchProcessItemList.length; bi++) {
				var batchItem = this.batchProcessItemList[bi];

				for (var i = 0; i < batchItem.batchProcessBoxCount; i++) {
					var addedBox = await this.addBoxConfirm(true);
					this.$nextTick(function() {
						if (this.$refs['weight'][this.boxes.length - 1].$el.offsetParent.offsetTop + 2 * this.$refs['weight'][this.boxes.length - 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
							this.$refs.div_wrapper_box.scrollTop += this.$refs['weight'][this.boxes.length - 1].$el.offsetParent.scrollHeight + 1;
						}
					});
					if (addedBox) {
						var boxItem = _.cloneDeep(batchItem);
						//console.log(boxItem);
						boxItem.box_no = this.selectedBox.box_no;

						boxItem.quantity = batchItem.packing;
						boxItem.original_quantity = batchItem.packing;
						this.boxItems.push(boxItem);
						batchItem.boxed_quantity += batchItem.packing;

						//addedBox.weight = this.batchWeight;
						if (batchItem.weight_per_box > 0) addedBox.weight = batchItem.weight_per_box;
						else addedBox.weight = weight;

						if (batchItem.box_length > 0) addedBox.length = batchItem.box_length;
						if (batchItem.box_width > 0) addedBox.width = batchItem.box_width;
						if (batchItem.box_height > 0) addedBox.height = batchItem.box_height;

						if (this.invoice.zone_code) addedBox.freight = this.calFreight(addedBox.weight);

						// this.$nextTick(() => {
						// 	addedBox.weight = this.batchWeight;
						// });
					}
				}
			}

			// for (var i = 0; i < this.batchProcessBoxCount; i++) {
			// 	var addedBox = await this.addBoxConfirm();
			// 	if (addedBox) {
			// 		var boxItem = _.cloneDeep(this.batchProcessItem);
			// 		boxItem.box_no = this.selectedBox.box_no;

			// 		boxItem.quantity = this.batchProcessItem.packing;
			// 		boxItem.original_quantity = this.batchProcessItem.packing;
			// 		this.boxItems.push(boxItem);
			// 		this.batchProcessItem.boxed_quantity += this.batchProcessItem.packing;

			// 		//addedBox.weight = this.batchWeight;
			// 		addedBox.weight = weight;
			// 		if (this.invoice.zone_code) addedBox.freight = this.calFreight(addedBox.weight);

			// 		// this.$nextTick(() => {
			// 		// 	addedBox.weight = this.batchWeight;
			// 		// });
			// 	}
			// }

			this.$nextTick(() => {
				this.selectedBox = {};
			});

			this.$toast.success('Item(s) Added');
			this.$toast.warning('Please Save...');
			this.modified = true;

			//this.$forceUpdate();
			//console.log(this.boxes);

			this.closeModal();
		},
		async dblclickFromItem(item) {
			await this.addToBox(item, true);
			// this.$nextTick(function() {
			// 	this.$refs.barcode_to_find.focus();
			// });
		},
		async addToBoxByQrcode(item_by_qrcode, b_type) {
			//console.log(item_by_qrcode);
			if (!this.selectedBox.box_no) {
				this.$toast.error('Box Not Selected.');
				return;
			}

			const item = this.findItemByItemCode(item_by_qrcode.item_code);
			if (!item) {
				this.$toast.error('Invalid Item');
				return;
			}

			//console.log(item);

			var found_item = this.findItemFromBoxByLot(this.selectedBox.box_no, item.invoice_item_no, item_by_qrcode.lot_no);
			if (item.quantity - item.boxed_quantity > 0) {
				var scan_quantity = 1;
				if (b_type == 'BX') scan_quantity = item.packing;
				else if (b_type == 'CS') scan_quantity = item.case_packing;

				var boxItem;
				if (found_item) {
					found_item.quantity += scan_quantity;
				} else {
					boxItem = _.cloneDeep(item);
					boxItem.box_no = this.selectedBox.box_no;

					boxItem.quantity = scan_quantity;
					boxItem.original_quantity = scan_quantity;
					boxItem.lot_no = item_by_qrcode.lot_no;
					boxItem.location_code = item_by_qrcode.location_code;
					boxItem.location_name = item_by_qrcode.location_name;
					boxItem.bin = item_by_qrcode.bin;
					//console.log(boxItem);

					this.boxItems.push(boxItem);
					item.boxed_quantity += scan_quantity;
				}

				this.$toast.success('Item Added');
				this.playScanSound('ok');
				this.$toast.warning('Please Save...');
				this.modified = true;
			}
		},
		async addToBox(item, all_quantity, batchFrom, b_type, multiply_qty) {
			// b_type : PC or BX or CS / multiply_qty : #3145 jc 추가 UPC 슬롯의 Multiply Qty (null=1)
			//console.log(item, batchFrom, b_type);
			this.scanned_item_id = item.item_id;
			//console.log(item.packing);

			//console.log(item.packing, item.balance);

			var next_input_focus = '';

			if (item.selected) {
				if (!this.selectedBox.box_no) {
					this.$toast.error('Box Not Selected');
					return;
				}
				if (this.selectedBox.wholebox) {
					this.$toast.warning('Selected box has whole-box item');
				}

				this.filteredItems
					.filter(selItem => selItem.selected)
					.forEach(eachItem => {
						var found_item = this.findItemFromBox(this.selectedBox.box_no, eachItem.invoice_item_no);

						//var scan_quantity = item.quantity - item.boxed_quantity; // - (item.scan_quantity ? item.scan_quantity : 0);
						if (eachItem.quantity - eachItem.boxed_quantity > 0) {
							var scan_quantity = all_quantity ? eachItem.quantity - eachItem.boxed_quantity : 1;
							var boxItem;
							if (found_item) {
								found_item.quantity += scan_quantity;
							} else {
								boxItem = _.cloneDeep(eachItem);
								boxItem.box_no = this.selectedBox.box_no;

								boxItem.quantity = scan_quantity;
								boxItem.original_quantity = scan_quantity;
								this.boxItems.push(boxItem);
								eachItem.boxed_quantity += scan_quantity;
							}
							// var index = this.filteredItems.findIndex(function(i) {
							// 	return i.invoice_item_no === eachItem.invoice_item_no;
							// });

							//console.log(index, this.$refs['item'][index].offsetTop);
							//this.$refs.div_wrapper.scrollTop = this.$refs['item'][index].offsetTop;
							//console.log(this.$refs.item[index].$el.offsetParent.offsetTop);

							//this.$toast.success('Item Added');
						} else {
							this.$toast.error('No balance');
							this.playScanSound('error');
						}
					});
				this.$toast.success('Item(s) Added');
				this.$toast.warning('Please Save...');
				this.modified = true;

				this.items.forEach(i => {
					i.selected = false;
					i.class_selected = false;
				});
				this.allSelected = false;
				this.$forceUpdate();
				//Batch로 작업
				//} else if (all_quantity && !this.selectedBox.box_no && item.packing > 0 && item.balance > 0 && item.balance % item.packing == 0) {
			} else if (all_quantity && !this.selectedBox.box_no && item.packing > 0 && item.balance > 0 && item.balance >= item.packing) {
				//console.log(item.packing, item.boxed_quantity);

				//console.log(batchFrom, sameClassItems);
				this.batchProcessItemList = [];
				this.batchFrom = batchFrom;
				if (this.batchFrom == 'unit') {
					//this.batchProcessBoxCount = 1;
					item.batchProcessBoxCount = 1;
					this.batchProcessItemList.push(item);
				} else {
					//var sameClassList = this.filteredItems.filter(i => i.class_code == item.class_code && i.packing > 0 && i.balance > 0 && i.balance % i.packing == 0);
					var sameClassList = this.filteredItems.filter(i => i.class_code == item.class_code && i.packing > 0 && i.balance > 0 && i.balance >= i.packing);
					if (sameClassList.length > 1) {
						if (confirm('Apply to other item(s) of the same class? Press OK to process all class items. Press Cancel to apply only this item')) {
							this.batchProcessItemList = sameClassList;
						} else {
							this.batchProcessItemList.push(item);
						}
					} else {
						this.batchProcessItemList.push(item);
					}

					//this.batchProcessItemList = this.filteredItems.filter(i => i.class_code == item.class_code && i.packing > 0 && i.balance > 0 && i.balance % i.packing == 0);
					//this.batchProcessBoxCount = item.balance / item.packing;
					this.batchProcessItemList.forEach(i => {
						i.batchProcessBoxCount = parseInt(i.balance / i.packing);
					});
				}

				//this.batchProcessItem = item;
				//console.log(this.$refs.input_weight);

				//if (item.weight_per_box > 0) {
				//console.log(this.batchProcessItemList.filter(i => i.weight_per_box > 0).length, this.batchProcessItemList.length);
				var totalBoxCount = 0;
				this.batchProcessItemList
					.filter(i => i.batchProcessBoxCount > 0)
					.forEach(i => {
						totalBoxCount += i.batchProcessBoxCount;
					});

				if (totalBoxCount > 20) {
					if (!confirm('More than 20 boxes will be added. Are you sure to continue?')) return;
				}

				if (this.batchProcessItemList.filter(i => i.weight_per_box > 0).length === this.batchProcessItemList.length) {
					await this.confirmBatchBoxing(); //각자 무게로..
				} else {
					this.modalName = 'Weight';
					this.showModal = true;
					next_input_focus = 'input_weight';
					// this.$nextTick(() => {
					// 	this.$refs.input_weight.$el.focus();
					// });
				}

				// var toAddBoxCount = item.balance / item.packing;

				// for (var i = 0; i < toAddBoxCount; i++) {
				// 	await this.addBoxConfirm();
				// 	boxItem = _.cloneDeep(item);
				// 	boxItem.box_no = this.selectedBox.box_no;

				// 	boxItem.quantity = item.packing;
				// 	boxItem.original_quantity = item.packing;
				// 	this.boxItems.push(boxItem);
				// 	item.boxed_quantity += item.packing;
				// }
				// this.$nextTick(() => {
				// 	this.selectedBox = {};
				// });
				//
				//this.$toast.success('Item(s) Added');
			} else {
				if (!this.selectedBox.box_no) {
					if (all_quantity) this.$toast.error('Box Not Selected. If you intend to insert multiple boxes. Please check box-packing quantity of the item or the class.');
					else this.$toast.error('Box Not Selected.');
					return;
				}

				if (this.selectedBox.wholebox) {
					this.$toast.warning('Selected box has whole-box item');
				}

				var found_item = this.findItemFromBox(this.selectedBox.box_no, item.invoice_item_no);
				var dummy = true;
				//if (!found_item) {
				if (dummy) {
					//var scan_quantity = item.quantity - item.boxed_quantity; // - (item.scan_quantity ? item.scan_quantity : 0);
					if (item.quantity - item.boxed_quantity > 0) {
						var scan_quantity = all_quantity ? item.quantity - item.boxed_quantity : 1;
						if (b_type == 'BX') scan_quantity = item.packing;
						else if (b_type == 'CS') scan_quantity = item.case_packing;
						else if (multiply_qty > 1) scan_quantity = multiply_qty; // #3145 jc 추가 UPC Multiply Qty

						var boxItem;
						if (found_item) {
							found_item.quantity += scan_quantity;
						} else {
							boxItem = _.cloneDeep(item);
							boxItem.box_no = this.selectedBox.box_no;

							boxItem.quantity = scan_quantity;
							boxItem.original_quantity = scan_quantity;
							this.boxItems.push(boxItem);
							item.boxed_quantity += scan_quantity;
						}
						//var boxItem = _.cloneDeep(item);

						//this.boxItems.push(boxItem);

						//item.scan_quantity += scan_quantity;
						//this.boxItems.push(item);
						//this.$toast.success('Item Added. Click "Save" button when packing is finished per each box.');

						//this.$refs.div_wrapper.scrollTop = this.$refs[ref][index + 1].$el.offsetParent.offsetTop;

						// var index = this.filteredItems.findIndex(function(i) {
						// 	return i.invoice_item_no === item.invoice_item_no;
						// });

						//console.log(index, this.$refs['item'][index].offsetTop);
						//this.$refs.div_wrapper.scrollTop = this.$refs['item'][index].offsetTop;
						//console.log(this.$refs.item[index].$el.offsetParent.offsetTop);

						this.$toast.success('Item Added');
						this.playScanSound('ok');
						this.$toast.warning('Please Save...');
						this.modified = true;
					} else {
						this.$toast.error('No balance');
						this.playScanSound('error');
						this.scanBlockAlert('Over Quantity', (item.class_code || 'Item') + ' is being packed more than the order quantity!<br>Order Qty: ' + item.quantity + '<br>Packed Qty: ' + item.boxed_quantity + '<br>This item will not be processed.');
					}

					//this.selectedBox.quantity += item.quantity;
				}
			}

			this.$nextTick(() => {
				this.$refs.div_wrapper_boxed_item.scrollTop = 10000000;
			});

			if (next_input_focus == 'input_weight')
				this.$nextTick(() => {
					this.$refs.input_weight.$el.focus();
				});

			// if (found_item) {
			// 	found_item.quantity++;
			// 	this.boxItems = this.boxItems.slice();
			// } else {
			// 	item.quantity = 1;
			// 	this.boxItems.push(item);
			// }

			//this.selectedBox.quantity++;
		},
		removeFromBox(item_to_remove, batch) {
			//console.log(item.invoice_item_no);
			if (!this.selectedBox.box_no) {
				this.$toast.error('Box Not Selected');
				return;
			}

			// #3165 : jc(lot) 는 한 박스에 같은 invoice_item_no 행이 여러 개일 수 있어 값 비교로는
			// 항상 첫 행이 지워진다(lot_no 를 더해도 둘 다 NULL 인 행은 구분되지 않는다).
			// v-for 가 넘겨주는 객체가 곧 boxItems 의 원소이므로 객체 동일성으로 찾는다. 타사는 기존 동작 유지.
			const idx =
				this.user.company_id == 'jc'
					? this.boxItems.indexOf(item_to_remove)
					: this.boxItems.findIndex(function(item) {
							//return item.invoice_item_no === item_to_remove.invoice_item_no;
							return item.invoice_item_no === item_to_remove.invoice_item_no && item.box_no === item_to_remove.box_no;
					  });
			if (idx > -1) {
				var found_item = this.findItem(item_to_remove.invoice_item_no);
				if (found_item) {
					//console.log(found_item);
					found_item.boxed_quantity -= this.boxItems[idx].quantity;
				}

				this.selectedBox.quantity -= this.boxItems[idx].quantity;
				this.boxItems.splice(idx, 1);

				//this.$toast.success('Item Removed. Click "Save" button when packing is finished per each box.');
				if (!batch) this.$toast.success('Item Removed.');
				this.modified = true;
			}
		},
		clearBox() {
			if (!this.selectedBox.box_no) {
				this.$toast.error('Box Not Selected');
				return;
			}
			//console.log('clear box');
			this.filteredBoxItems.forEach(bi => {
				this.removeFromBox(bi, true);
			});
			this.selectedBox.weight = null;
			this.$toast.success('Box Cleared.');
		},
		async selectBox(box) {
			//console.log('Hmmmm1', this.selectedBox);
			//console.log('Hmmmm2', box);
			//if (this.selectedBox == box) return;

			// this.selectedItem = {};
			// this.boxes.forEach(box => {
			// 	box.checked = false;
			// });

			this.items.forEach(i => {
				i.exists_in_the_box = false;
			});

			if (this.selectedBox == box) this.selectedBox = {};
			//console.log(box);
			//this.boxItems = [];
			else {
				this.selectedBox = box;
				var f_items = this.boxItems.filter(i => i.box_no == this.selectedBox.box_no);
				if (f_items.length > 0) {
					var index = this.findIndexInItems(f_items[0].invoice_item_no);
					//console.log(index);
					this.$nextTick(function() {
						if (index >= 0) this.$refs.div_wrapper_item.scrollTop = this.$refs['item'][index].offsetTop;
					});
				}

				f_items.forEach(fi => {
					this.items
						.filter(i => i.invoice_item_no == fi.invoice_item_no)
						.forEach(i => {
							i.exists_in_the_box = true;
						});
				});
				//				console.log(this.boxItems.filter(i => i.box_no == this.selectedBox.box_no));
			}

			//console.log(this.boxItems);
			//console.log(this.selectedBox);
			//this.filteredBoxItems = this.boxItems.filter(i => i.box_no == this.selectedBox.box_no);

			// const { data } = await apiSelectBoxItemList({
			// 	box_no: box.box_no,
			// });

			// this.boxItems = data.boxItemList;
			inputSelectOnClick();
			//console.log(this.boxItems);
		},
		async selectItem(item) {
			//if (this.selectedItem == item || !(item.boxed_quantity > 0)) return;
			var first_box_checked = -1;

			// this.selectedBox = {};

			// this.items.forEach(i => {
			// 	i.exists_in_the_box = false;
			// });

			this.selectedItem = item;
			//console.log('select item');
			//console.log(this.boxItems);
			this.boxes.forEach(box => {
				box.checked = false;
			});

			this.boxItems.forEach(boxItem => {
				if (item.invoice_item_no == boxItem.invoice_item_no) {
					//console.log(boxItem.box_no);
					const idx = this.boxes.findIndex(function(box) {
						return box.box_no === boxItem.box_no;
					});
					if (idx >= 0) {
						this.boxes[idx].checked = true;
						if (first_box_checked == -1) first_box_checked = idx;
					}
				}
				//item.balance = item.quantity - item.boxed_quantity - (item.scan_quantity ? item.scan_quantity : 0);
				//console.log(item.balance);
			});
			this.$forceUpdate();

			if (first_box_checked >= 0) {
				//console.log('first box checked : ', first_box_checked);
				this.$refs.div_wrapper_box.scrollTop = this.$refs['weight'][first_box_checked].$el.offsetParent.offsetTop;
			}
		},
		async addBox() {
			if (this.isVoid()) return;

			await this.addBoxConfirm(false);
			this.$nextTick(function() {
				// if (this.$refs['weight'][this.boxes.length - 1].$el.offsetParent.offsetTop + 2 * this.$refs['weight'][this.boxes.length - 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
				// 	this.$refs.div_wrapper_box.scrollTop += this.$refs['weight'][this.boxes.length - 1].$el.offsetParent.scrollHeight + 1;
				// }

				this.$refs.div_wrapper_box.scrollTop = this.$refs.div_wrapper_box.scrollHeight;
				this.$refs.barcode_to_find.focus();
			});
		},
		addMultipleBoxes() {
			if (this.isVoid()) return;

			if (!this.invoice.invoice_no) {
				this.$toast.error('Invalid Sales Order');
				return;
			}
			this.modalName = 'MultipleBoxes';
			this.showModal = true;
			this.$nextTick(() => {
				this.$refs.multiple_boxes_count.$el.focus();
			});
			// await this.addBoxConfirm();
			// this.$nextTick(function() {
			// 	if (this.$refs['weight'][this.boxes.length - 1].$el.offsetParent.offsetTop + 2 * this.$refs['weight'][this.boxes.length - 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
			// 		this.$refs.div_wrapper_box.scrollTop += this.$refs['weight'][this.boxes.length - 1].$el.offsetParent.scrollHeight + 1;
			// 	}
			// 	this.$refs.barcode_to_find.focus();
			// });
		},
		async confirmMultipleBoxes() {
			if (this.multipleBoxesWeight <= 0) {
				this.$toast.error('Invalid Weight');
				return;
			}

			//console.log(this.multipleBoxesCount, this.multipleBoxesWeight);
			this.showModal = false;
			var added = 0;
			for (var i = 0; i < this.multipleBoxesCount; i++) {
				if (!(await this.addBoxConfirm(false, this.multipleBoxesWeight, true, this.multipleBoxesLength, this.multipleBoxesWidth, this.multipleBoxesHeight))) break;
				added++;
			}
			if (added > 0) this.$toast.success(added + ' Box(es) Added');
		},
		async addBoxConfirm(wholebox, weight, multiple, length, width, height) {
			var freight;

			if (!this.invoice.invoice_no) {
				this.$toast.error('Invalid Sales Order');
				return;
			}
			//console.log('add box');
			var param = {
				invoice_no: this.invoice.invoice_no,
			};
			if (weight) {
				param.weight = weight;
				if (this.invoice.zone_code) {
					freight = this.calFreight(weight);
					param.freight = freight;
				}
			}

			if (wholebox) param.wholebox = 1;
			else param.wholebox = 0;

			if (length) param.length = length;
			if (width) param.width = width;
			if (height) param.height = height;

			//console.log(param);

			const { data } = await apiInsertBox(param);

			if (data.result) {
				/*
				var newBox = {
					box_no: data.box_no,
					wholebox: wholebox,
					crt_user: this.user.user_id,
					order_no: data.order_no,
					box_dn: data.box_dn,
				}; */
				var newBox = data.newBox;

				//console.log(newBox);
				if (weight) {
					newBox.weight = weight;
					newBox.freight = freight;
					newBox.manual_weight = true;
				}

				if (length) newBox.length = length;
				if (width) newBox.width = width;
				if (height) newBox.height = height;

				this.boxes.push(newBox);
				//this.boxes = data.boxList;
				this.selectedBox = newBox;
				this.$forceUpdate();

				if (!multiple) this.$toast.success('Box Added');
				return newBox;
			} else {
				this.$toast.error(data.msg);
				this.markBoxesLocked(data);
				return null;
			}
		},
		async printBox(box_dn) {
			const { data } = await apiPackingBoxItem(this.invoice.invoice_no);
			let box = data.list.find(box => box.box_dn === box_dn);
			const boxData = { result: true, list: [box], printMarkingText: data.printMarkingText, company: data.company, delivery_type_code: data.delivery_type_code, ship_to_address: this.makeShipmentAddress(data.shipment) };
			boxData.list[0].frontBoxNo = box_dn;
			if (data.result) {
				const reportTemplate = await apiGetReportTemplate('PackingBox', companyMrtUrl('PackingBox'));
				const report = new Report(reportTemplate, boxData, 'PackingBox');
				this.$store.commit('setReport', report);
			}
		},
		// #3165 : 삭제된 박스의 아이템을 화면 상태에서도 제거하고, 담겨 있던 수량을 되돌린다.
		//         boxItems 에 남겨두면 Save 때 그대로 다시 전송되어 서버에 고아 행으로 쌓이고,
		//         boxed_quantity 를 되돌리지 않으면 남은 수량이 실제보다 적게 보여 재스캔이 막힌다.
		// #3165 : 삭제·조회로 사라진 박스가 통합 선택에 남지 않게 정리한다.
		dropMergeSelection(box_nos) {
			if (!box_nos) {
				this.mergeBoxNos = [];
				return;
			}
			this.mergeBoxNos = this.mergeBoxNos.filter(n => box_nos.indexOf(n) < 0);
		},
		releaseBoxItems(box_nos) {
			this.boxItems
				.filter(bi => box_nos.indexOf(bi.box_no) > -1)
				.forEach(bi => {
					const found_item = this.findItem(bi.invoice_item_no);
					if (found_item) found_item.boxed_quantity -= bi.quantity;
				});

			this.boxItems = this.boxItems.filter(bi => box_nos.indexOf(bi.box_no) < 0);
		},
		// #3165 : 통합 대상 체크 토글. 행 클릭(selectBox)과 겹치지 않도록 호출부에 @click.stop 이 걸려 있다.
		toggleMergeBox(box) {
			const idx = this.mergeBoxNos.indexOf(box.box_no);
			if (idx > -1) this.mergeBoxNos.splice(idx, 1);
			else this.mergeBoxNos.push(box.box_no);
		},
		async mergeBoxesConfirm() {
			if (!this.mergeBoxesUsable) return;

			if (this.mergeBoxNos.length < 2) {
				this.$toast.error('Check at least two boxes to merge.');
				return;
			}

			// 통합은 DB 행만 옮긴다. 저장하지 않은 스캔이 원본 박스에 남아 있으면 되돌릴 수 없이 사라지므로
			// 먼저 저장에 성공한 경우에만 진행한다. saveBoxItems 는 true/false 를 돌려준다.
			if (this.modified) {
				if (!(await this.saveBoxItems(true))) return;
			}

			// #3165 : 확정 target 배열 하나만 쓴다. 조회·삭제로 사라진 박스가 선택에 남아 있으면 여기서 걸러진다.
			const targets = this.boxes.filter(b => this.mergeBoxNos.indexOf(b.box_no) > -1);
			if (targets.length !== this.mergeBoxNos.length) this.mergeBoxNos = targets.map(b => b.box_no);
			if (targets.length < 2) {
				this.$toast.error('Check at least two boxes to merge.');
				return;
			}
			const target_box_nos = targets.map(b => b.box_no);
			const box_dns = targets.map(b => b.box_dn || b.box_no).join(', ');

			var vm = this;
			this.$alertify.confirm('Merge box ' + box_dns + ' into one new box? The original boxes will be deleted.', function() {
				vm.mergeBoxesRun(target_box_nos);
			});
		},
		async mergeBoxesRun(target_box_nos) {
			// 서버가 "선택 시점 이후 원본이 바뀌었는지" 를 판정할 수 있도록 화면이 보고 있던 구성을 그대로 보낸다.
			// 해시는 서버가 양쪽 다 계산한다(브라우저 crypto.subtle 의존을 피하기 위함).
			const client_items = this.boxItems
				.filter(bi => target_box_nos.indexOf(bi.box_no) > -1)
				.map(bi => ({
					box_no: bi.box_no,
					invoice_item_no: bi.invoice_item_no,
					lot_no: bi.lot_no,
					quantity: bi.quantity,
				}));

			const { data } = await apiMergeBoxes({
				invoice_no: this.invoice.invoice_no,
				box_nos: target_box_nos.slice(),
				client_items: client_items,
				for_boxing: true,
			});

			if (!data.result) {
				this.$toast.error(data.msg);
				return;
			}

			// 서버 상태로 두 목록을 동시에 교체한다. 하나만 갱신하면 다음 저장이 통합 박스를 비워버린다.
			this.boxes = data.boxList;
			this.boxItems = data.boxItemList;
			this.boxItems.forEach(bi => {
				bi.original_quantity = bi.quantity;
			});

			// 파생 상태 재구성 - 담긴 수량은 서버 기준으로 다시 계산한다.
			this.items.forEach(i => {
				i.boxed_quantity = this.boxItems.filter(bi => bi.invoice_item_no == i.invoice_item_no).reduce((acc, cur) => acc + Number(cur.quantity || 0), 0);
				i.exists_in_the_box = false;
			});

			this.mergeBoxNos = [];
			this.modified = false;
			this.selectedBox = this.boxes.filter(b => b.box_no == data.new_box_no)[0] || {};

			this.$forceUpdate();

			this.$toast.success('Boxes Merged');
			this.$toast.warning('Check the merged box weight and dimensions, then Save. Re-print the packing / pallet labels.', { duration: 10000 });
		},
		async delEmptyBoxes() {
			//임시
			// for (var i = this.boxes.length - 1; i >= 0; i--) {
			// 	if (!this.boxes[i].quantity && !this.boxes[i].weight) await this.delBox(this.boxes[i], i);
			// }

			// var dummy = true;
			// if (dummy) return;

			var toDelBoxes = _.cloneDeep(this.boxes.filter(b => !b.weight && !b.quantity));
			if (toDelBoxes.length == 0) return;

			const { data } = await apiDeleteBoxBatch({ boxes: toDelBoxes, invoice_no: this.invoice.invoice_no });
			//console.log(toDelBoxes);
			var vm = this;
			if (data.result) {
				//this.boxes.splice(index, 1);
				toDelBoxes.forEach(db => {
					const idx = vm.boxes.findIndex(function(box) {
						return box.box_no === db.box_no;
					});
					if (idx > -1) {
						if (vm.selectedBox.box_no == db.box_no) vm.selectedBox = {};
						this.boxes.splice(idx, 1);
					}
				});
				this.releaseBoxItems(toDelBoxes.map(db => db.box_no));
				this.dropMergeSelection(toDelBoxes.map(db => db.box_no));
				this.$toast.success(toDelBoxes.length + ' Box(es) Deleted');
			} else {
				this.$toast.error(data.msg);
				this.markBoxesLocked(data);
			}
		},
		async delBox(box, index) {
			const { data } = await apiDeleteBox(box);

			if (this.selectedBox.box_no == box.box_no) this.selectedBox = {};

			if (data.result) {
				this.boxes.splice(index, 1);
				this.releaseBoxItems([box.box_no]);
				this.dropMergeSelection([box.box_no]);
				this.$toast.success('Box Deleted');
			} else {
				this.$toast.error(data.msg);

				if (data.box_locked) {
					this.markBoxesLocked(data);
					return;
				}
			}

			if (this.invoice.status_code == 'I' || this.invoice.status_code == 'VI') {
				//this.$alertify.alert('Warning', 'Box count or total weight of the order may have changed. Please save...');
				beep();
				this.$alertify
					.alert()
					.setContent('<h2><font color="red">Box count or total weight of the order may have changed.<br/><br/>Please save !!!!!!!</font></h2>')
					.show();
			}
		},
		// #3149 : the server refused a box add/delete because the SO is already invoiced.
		// Only raise the lock flag so the Add / Del buttons disappear. Never reload the invoice and
		// never touch unsaved scan state - saving box items (updateBoxItemList) stays allowed on purpose.
		markBoxesLocked(data) {
			if (data && data.box_locked) this.boxes_locked = true;
		},
		async adjBox(box) {
			//console.log(box, this.computedBoxQuantity(box.box_no));
			const { data } = await apiAdjustBox({
				box_no: box.box_no,
				quantity: this.computedBoxQuantity(box.box_no),
			});
			if (data.result) {
				this.$toast.success('Box Adjusted');
				box.quantity = this.computedBoxQuantity(box.box_no);
			} else {
				this.$toast.error(data.msg);
			}
		},
		reset() {
			this.dropMergeSelection();
			this.invoice = {};
			this.boxes_locked = false;
			this.boxes = [];
			this.items = [];
			this.boxItems = [];
			this.selectedBox = {};
			this.so_dn = null;
			this.invoice_dn = null;
			this.zoneChargeList = [];
			this.location_code = null;
			//this.balance_only = false;
			this.whole_box_only = false;

			this.barcode_to_find = null;
			this.barcode_whole_unit = null;
			this.barcode_whole_full = null;
			this.qrcode_to_find = null;

			this.$nextTick(function() {
				this.$refs.so_dn.$el.children[0].focus();
			});
		},
		setInvoice() {
			this.search(true);
			//for test
		},
		async search(tag_packing_start_time) {
			this.dropMergeSelection();
			if (this.searching) return;

			if (this.modified) {
				if (!confirm('Loading other SO without saving changes of this SO?')) return;
			}

			if (!this.so_dn && !this.invoice_dn) {
				this.$toast.error('Empty SO /Inv No.');
				return;
			}

			this.searching = true;

			//this.loadingCompleted = false;

			this.boxes_locked = false;
			this.boxes = [];
			this.items = [];
			this.boxItems = [];
			this.zoneChargeList = [];
			this.selectedBox = {};
			this.selectedItem = {};
			this.location_code = null;
			//this.balance_only = false;
			this.apply_inv_quantity_yn = 'Y';
			this.scanned_item_id = null;
			//console.log('Searching SO:', this.sono);
			var param = {
				//invoice_no: this.invoice.invoice_no,
				so_dn: this.so_dn,
				invoice_dn: this.invoice_dn,
				//status_code: 'P',
				for_boxing: true,
				include_ship_to_address: true,
				include_locked_item: true,
			};
			if (tag_packing_start_time) param.tag_packing_start_time = true;

			//const { data } = await apiSelectInvoice(param);

			var response = await apiSelectInvoice(param);

			if (response.data.invoice && response.data.invoice.invoice_type == 'R') {
				var returned_from_invoice_no = response.data.invoice.returned_from_invoice_no;
				if (returned_from_invoice_no > 0) {
					response = await apiSelectInvoice({
						invoice_no: returned_from_invoice_no,
						for_boxing: true,
						include_locked_item: true,
					});
					this.$toast.success('Loading packing information of original Invoice');
					if (response.data.invoice) {
						this.so_dn = response.data.invoice.so_dn;
						this.invoice_dn = response.data.invoice.invoice_dn;
					}
				}
			}

			var data = response.data;
			//console.log(data);

			if (!data.invoice) {
				this.invoice = {};
				this.$toast.error('Not found..');
				// } else if (data.invoice.status_code == 'I') {
				// 	this.invoice = {};
				// 	this.$alertify.alert('Alert', 'Invoiced sales order');
			} else {
				this.invoice = data.invoice;
				this.shipToAddress = data.shipToAddress;

				if (this.invoice.status_code == 'I' || this.invoice.status_code == 'VI') this.apply_inv_quantity_yn = 'N';
				if (this.user.company_id == 'beautyplus' && this.invoice.status_code == 'I') this.boxes_locked = true;
				this.boxes = data.boxList;
				//console.log(this.boxes);
				this.items = data.invoiceItemList;
				//console.log(this.items);
				this.boxItems = data.boxItemList;
				this.boxItems.forEach(bi => {
					bi.original_quantity = bi.quantity;
				});
				this.zoneChargeList = data.zoneChargeList;
				this.lots = data.lotList;
				//console.log(this.lots);

				if (!this.so_dn) this.so_dn = this.invoice.so_dn;
				if (!this.invoice_dn && this.invoice.invoice_dn) this.invoice_dn = this.invoice.invoice_dn;

				this.isVoid();

				if (this.invoice.status_code == 'I') {
					this.$alertify.alert('Alert', 'Invoiced sales order. Update is not allowed.');
				}

				//console.log(this.invoice.remark);
				this.invoice.wh_remark = null;
				if (this.invoice.remark) {
					var pos = this.invoice.remark.indexOf('||');
					if (pos >= 0) {
						this.invoice.wh_remark = this.invoice.remark.substring(pos + 2).trim();
						this.invoice.front_remark = this.invoice.remark.substring(0, pos).trim();
					} else {
						this.invoice.front_remark = this.invoice.remark;
					}
					//console.log(this.invoice);
				}
				//console.log(this.invoice);
			}

			this.searching = false;

			//this.load_complete = true;

			//this.changed = false;
			//this.loadingCompleted = true;
		},
		isVoid() {
			if (this.invoice.status_code == 'V') {
				beep();
				this.$alertify.alert('Voided', 'Stop packing.<br/><br/>Report to the warehouse manager');
				return true;
			} else {
				return false;
			}
		},
		async index() {
			// const { data } = await apiIndex();
			// this.locations = data.locationList;
			// console.log(this.locations);
			const { data } = await apiSoIndex();

			this.paymentTerms = data.paymentTermList;
			this.shipCharges = data.shipChargeList;
			this.salesGroups = data.salesGroupList;
			this.deliveryTypes = data.deliveryTypeList;
			this.remarks = data.remarkList;
			this.specialSales = data.specialSaleList;

			this.locations = data.locationList;
			this.locations.unshift({ code: null, name: '(ALL)' });

			this.pallets = data.palletList;
			// this.pallets.forEach(p => {
			// 	p.name = p.description;
			// });
			console.log(this.pallets);
			//console.log(this.locations);
		},
		async init() {
			await this.index();
			this.saleStatusCodes = this.$saleStatusCodes;

			if (this.$route.query.so_dn) {
				this.so_dn = this.$route.query.so_dn;
				if (this.$route.query.from_where == 'packing_status') {
					this.balance_only = true;
					this.setBalanceOnly();
				}

				this.setInvoice();
			}
			//await this.index();
			//if (this.$route.query.sono) this.sono = this.$route.query.sono;
			//await this.selectInvoices();
		},
		barcodeScanned() {
			var barcode_data = $('#barcode_data').val();
			//console.log('Hm.....', barcode_data);

			if (barcode_data) {
				if (this.invoice.invoice_no) {
					//console.log('search item', barcode_data);
				} else {
					this.so_dn = barcode_data;
					this.search(true);
				}
			}
			//console.log('Hm.....', this.barcode_data);
		},
		setBalanceOnly() {
			//console.log(this.auto_refresh);
			this.$session.set('balance_only', this.balance_only);
		},
		// beforeWindowUnload(e) {
		// 	alert('test');
		// 	console.log('beforeunload');
		// 	if (this.modified) {
		// 		if (confirm('Are you leaving without saving changes?')) e.returnvalue = '';
		// 		else e.preventDefault();
		// 	}
		// },
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_boxing');
		this.$store.commit('setSubTitle', 'Sales -> Packing Box');

		this.balance_only = this.$session.get('balance_only');

		//this.selectInvoices();
		this.init();

		// if (this.$route.query.so_dn) {
		// 	this.so_dn = this.$route.query.so_dn;
		// 	this.setInvoice();
		// }

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	beforeDestroy() {
		//window.removeEventListener('beforeunload', this.beforeWindowUnload);
	},

	mounted() {
		inputSelectOnClick();
		//initBarcodeScanner();

		//makeTableResizable();
		//window.addEventListener('beforeunload', this.beforeWindowUnload);

		this.$nextTick(function() {
			this.$refs.so_dn.$el.children[0].focus();
		});

		//document.addEventListener('barcode_scanned', this.barcodeScanned);
	},
	destroyed() {
		//window.removeEventListener('beforeunload', this.beforeWindowUnload);
		//document.removeEventListener('barcode_scanned', this.barcodeScanned);
	},
};
</script>

<style>
@keyframes blink-effect {
	50% {
		opacity: 0;
	}
}

.blink {
	animation: blink-effect 1s step-end infinite;

	/*
  animation-name: blink-effect;
  animation-duration: 1s;
  animation-iteration-count:infinite;
  animation-timing-function:step-end;
  */
}
</style>
